export const languageVietnamese = {
    "formating": {
        "main": "Lời nhắc chính",
        "jailbreak": "Lời nhắc bẻ khóa",
        "chats": "Cuộc trò chuyện trước đây",
        "lorebook": "Sách truyền thuyết",
        "globalNote": "Ghi chú chung",
        "authorNote": "Ghi chú của tác giả",
        "lastChat": "Cuộc trò chuyện cuối cùng",
        "description": "Mô tả nhân vật",
        "personaPrompt": "Lời nhắc của Persona",
        "plain": "Lời nhắc đơn giản",
        "memory": "Bộ nhớ Supa/Hypa",
        "postEverything": "End-Injected Prompts"
    },
    "errors": {
        "toomuchtoken": "Lỗi: Mã thông báo bắt buộc tối thiểu lớn hơn Kích thước ngữ cảnh tối đa.",
        "unknownModel": "Lỗi: Đã chọn mô hình không xác định",
        "httpError": "Lỗi: lỗi trong yêu cầu:",
        "noData": "Tệp này có vẻ không hợp lệ hoặc dữ liệu đã bị hỏng.",
        "onlyOneChat": "Phải có ít nhất một cuộc trò chuyện",
        "alreadyCharInGroup": "Đã có một nhân vật có cùng tên trong nhóm.",
        "noUserIcon": "Bạn phải đặt biểu tượng của mình trước.",
        "emptyText": "Text is empty.",
        "wrongPassword": "Wrong Password",
        "networkFetch": "This happens when the network is unstable or the server is down.",
        "networkFetchWeb": "This can be a CORS error. this only happens when using web version dude to limitations of the browser. try using desktop local version, or other version of Risuai.",
        "networkFetchPlain": "This can be a plain fetch error. try disabling force plain fetch option in settings.",
        "requestLogRemoved": "This request log is removed.",
        "requestLogRemovedDesc": "This request log removes when client is refreshed or reloaded.",
        "vertexAuthError": "Thiếu thông tin xác thực Vertex AI.",
        "coldStorageWriteFailed": "Ghi vào bộ nhớ lạnh thất bại. Dữ liệu trò chuyện của bạn đã được bảo toàn.",
        "coldStorageVerifyFailed": "Xác minh bộ nhớ lạnh thất bại. Dữ liệu trò chuyện của bạn đã được bảo toàn.",
        "coldStorageRestoreFailed": "Không thể tải dữ liệu bộ nhớ lạnh. Dữ liệu của nhân vật bị ảnh hưởng có thể đã bị mất vĩnh viễn.",
        "coldStorageIncompleteBackupConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `Dữ liệu bộ nhớ lạnh của ${characterNames || "nhân vật không xác định"} bị thiếu hoặc không hợp lệ.${unresolvedCount > 0 ? ` Có ${unresolvedCount} mục không thể liên kết với nhân vật.` : ""}\n\nNếu tiếp tục, bản sao lưu này sẽ thiếu ${unavailableCount} mục bộ nhớ lạnh và dữ liệu nhân vật hoặc cuộc trò chuyện bị ảnh hưởng có thể không thể khôi phục từ bản sao lưu.\n\nVẫn tạo bản sao lưu không đầy đủ?`,
        "coldStorageIncompleteRestoreConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `Không thể khôi phục dữ liệu bộ nhớ lạnh của ${characterNames || "nhân vật không xác định"}.${unresolvedCount > 0 ? ` Có ${unresolvedCount} mục không thể liên kết với nhân vật.` : ""}\n\nNếu tiếp tục, ${unavailableCount} mục bộ nhớ lạnh sẽ vẫn không khả dụng và dữ liệu nhân vật hoặc cuộc trò chuyện bị ảnh hưởng có thể bị mất vĩnh viễn.\n\nVẫn tiếp tục khôi phục không đầy đủ?`
    },
    "showHelp": "Hiển thị trợ giúp",
    "help": {
        "model": "Tùy chọn mô hình là mô hình chính được sử dụng trong trò chuyện.",
        "submodel": "Mô hình phụ trợ là mô hình được sử dụng để phân tích hình ảnh cảm xúc và đề xuất tự động, v.v. Nên sử dụng gpt3.5.",
        "oaiapikey": "Khóa Api cho OpenAI. bạn có thể lấy nó ở https://platform.openai.com/account/api-keys",
        "mainprompt": "Tùy chọn lời nhắc chính đặt hành vi mô hình mặc định.",
        "jailbreak": "Tùy chọn lời nhắc jailbreak kích hoạt khi nút chuyển đổi jailbreak được bật.",
        "globalNote": "một lưu ý có tác động mạnh mẽ đến hành vi của mô hình, còn được gọi là UJB. hoạt động ở tất cả các ký tự.",
        "autoSuggest": "Lời nhắc được sử dụng để tạo các tùy chọn khi tự động đề xuất phản hồi của người dùng.",
        "formatOrder": "thứ tự hình thành của lời nhắc. các khối thấp hơn sẽ có hiệu quả hơn đối với mô hình.",
        "forceUrl": "nếu nó không trống, yêu cầu sẽ chuyển đến url mà bạn đã nhập.",
        "tempature": "giá trị thấp hơn làm cho nhân vật tuân theo lời nhắc một cách chặt chẽ, nhưng nó sẽ có nhiều khả năng phản hồi giống như một cái máy hơn.\nGiá trị cao hơn sẽ dẫn đến hành vi sáng tạo, nhưng phản ứng của nhân vật có thể dễ dàng bị phá vỡ hơn.",
        "frequencyPenalty": "Giá trị cao hơn ngăn chặn việc sử dụng các từ trùng lặp trong phản hồi, nhưng phản hồi của nhân vật có thể dễ dàng bị hỏng hơn.",
        "presensePenalty": "Giá trị cao hơn sẽ ngăn chặn việc sử dụng các từ trùng lặp trong mọi ngữ cảnh, nhưng phản hồi của nhân vật có thể dễ bị phân tích hơn.",
        "sdProvider": "nhà cung cấp để tạo hình ảnh.",
        "msgSound": "Phát âm thanh *ding* khi nhân vật phản hồi",
        "charDesc": "Mô tả ngắn gọn về nhân vật. điều này ảnh hưởng đến phản ứng của nhân vật.",
        "charFirstMessage": "Tin nhắn đầu tiên của nhân vật. điều này ảnh hưởng lớn đến phản ứng của nhân vật.",
        "charNote": "một lưu ý có ảnh hưởng mạnh mẽ đến hành vi của mô hình. được nhúng vào ký tự hiện tại. còn được gọi là UJB.",
        "toggleNsfw": "bật và tắt lời nhắc jailbreak.",
        "lorebook": "Lorebook là một từ điển do người dùng tạo ra cho AI. AI chỉ nhìn thấy nó khi khóa kích hoạt ở đâu trong ngữ cảnh.",
        "loreName": "tên của truyền thuyết. nó không ảnh hưởng đến Ai.",
        "loreActivationKey": "Nếu một trong các khóa kích hoạt tồn tại trong ngữ cảnh, truyền thuyết sẽ được kích hoạt và lời nhắc sẽ xuất hiện, được phân tách bằng dấu phẩy.",
        "loreorder": "Nếu chèn Thứ tự cao hơn, nó sẽ ảnh hưởng đến mô hình nhiều hơn và nó sẽ ít bị cắt hơn khi truyền thuyết được kích hoạt nhiều.",
        "bias": "thiên vị là dữ liệu khóa-giá trị sửa đổi khả năng xuất hiện của chuỗi.\nnó có thể là -100 đến 100, các giá trị cao hơn sẽ có nhiều khả năng xuất hiện hơn và các giá trị thấp hơn sẽ khó xuất hiện hơn\nCảnh báo: nếu mã thông báo sai, nó sẽ không hoạt động bình thường.",
        "emotion": "Tùy chọn Hình ảnh Cảm xúc hiển thị hình ảnh tùy theo cảm xúc của nhân vật và được phân tích theo phản ứng của nhân vật. bạn phải nhập tên cảm xúc dưới dạng các từ *(như niềm vui, hạnh phúc, sợ hãi, v.v.)* .cảm xúc có tên **trung tính** sẽ là cảm xúc mặc định nếu nó tồn tại. phải có nhiều hơn 3 hình ảnh để hoạt động bình thường.",
        "imggen": "Tùy chọn Tạo hình ảnh tạo và hiển thị hình ảnh từ chương trình bên ngoài. hình ảnh được tạo bởi dấu nhắc hình ảnh, được tạo bằng cách phân tích cuộc trò chuyện hiện tại.\n\n việc tạo hình ảnh được phân tích dựa trên các đối số khóa-giá trị, có thể định cấu hình ở bên dưới.\nPhím Zn**'always'** luôn được áp dụng và không thay đổi. Phím **'âm'** luôn áp dụng giá trị âm để tạo hình ảnh.\n\ncác đối tượng có giá trị của khóa khác sẽ thay đổi theo tên của khóa khi cuộc trò chuyện diễn ra.\n\nNếu một phím có ký tự đặc biệt ở phía trước tên của nó thì phím đó có tác dụng đặc biệt.\n- nếu khóa bắt đầu bằng **|**, giá trị của khóa sẽ không thay đổi.\n- nếu khóa bắt đầu bằng *******, giá trị của khóa sẽ có nhiều khả năng thay đổi hơn.\n\nkhi hình ảnh được tạo lần đầu tiên, bạn chỉ có thể thay đổi nó bằng cách sửa đổi 'Dữ liệu tạo hình ảnh hiện tại' ở bên dưới.",
        "regexScript": "Regex Script là tập lệnh tùy chỉnh thay thế chuỗi khớp IN với OUT.\n\nCó bốn lựa chọn loại.\n\n- **Sửa đổi đầu vào** sửa đổi đầu vào của người dùng\n\n- **Sửa đổi đầu ra** sửa đổi đầu ra của ký tự\n\n- **Sửa đổi dữ liệu yêu cầu** sửa đổi dữ liệu trò chuyện hiện tại khi được gửi.\n\n- **Sửa đổi hiển thị** chỉ sửa đổi văn bản khi được hiển thị mà không sửa đổi dữ liệu trò chuyện.\n\nIN phải là biểu thức chính quy không có cờ và không có dấu gạch chéo ở đầu và cuối.\n\nOUT là một chuỗi có thể bao gồm các mẫu thay thế. đây là những mẫu:\n\n- $$\n\n    - chèn $\n\n- $&\n\n    - chèn chuỗi con phù hợp.\n\n- $`\n\n    - chèn phần chuỗi đứng trước chuỗi con phù hợp.\n\n- 1$\n\n    - chèn nhóm phù hợp đầu tiên. làm việc với số khác như 2, 3...\n\n- $(tên)\n\n    - chèn nhóm được đặt tên\n\nNếu OUT bắt đầu bằng **@@**, nó không thay thế chuỗi mà thay vào đó tạo ra hiệu ứng đặc biệt nếu tìm thấy chuỗi trùng khớp.\n\n- @@emo (tên cảm xúc)\n\n    - nếu nhân vật ở chế độ Hình ảnh Cảm xúc, hãy đặt (tên cảm xúc) làm cảm xúc và ngăn mặc định.",
        "experimental": "Đây là một tính năng thử nghiệm. nó có thể không ổn định.",
        "oogaboogaURL": "Nếu WebUI của bạn hỗ trợ phiên bản api cũ hơn thì url của bạn sẽ trông *như https:.../run/textgen*\n\nNếu WebUI của bạn hỗ trợ Phiên bản mới của api thì url của bạn sẽ trông giống như *https://.../api/v1/generate* và sử dụng máy chủ api làm máy chủ lưu trữ, đồng thời thêm --api vào đối số.",
        "exampleMessage": "Các cuộc hội thoại ví dụ ảnh hưởng đến đầu ra của nhân vật. nó không sử dụng mã thông báo vĩnh viễn.\n\nĐịnh dạng ví dụ của cuộc hội thoại:\n\n```\n<BẮT ĐẦU>\n{{user}}: xin chào\n{{char}}: xin chào\n<BẮT ĐẦU>\n{{user}}: xin chào\nHaruhi: xin chào\n```\n\n```<START>``` Đánh dấu sự bắt đầu của một cuộc trò chuyện mới.",
        "creatorQuotes": "Lưu ý rằng xuất hiện trên đầu tin nhắn đầu tiên. Được sử dụng để thông báo cho người dùng về nhân vật này. Nó không đi vào dấu nhắc.",
        "systemPrompt": "Lời nhắc thay thế lời nhắc chính trong cài đặt nếu nó không trống.",
        "chatNote": "một lưu ý có ảnh hưởng mạnh mẽ đến hành vi của mô hình. được nhúng vào cuộc trò chuyện hiện tại. còn được gọi là bộ nhớ hoặc ujb.",
        "personality": "Mô tả ngắn gọn về tính cách nhân vật.\n\n**Không nên sử dụng tùy chọn này. Thay vào đó hãy mô tả nó bằng phần mô tả nhân vật.**",
        "scenario": "Một mô tả ngắn gọn về kịch bản của nhân vật.\n\n**Không nên sử dụng tùy chọn này. Thay vào đó hãy mô tả nó bằng phần mô tả nhân vật.**",
        "utilityBot": "Khi được kích hoạt, nó sẽ bỏ qua lời nhắc chính, bẻ khóa và các lời nhắc khác. Được sử dụng cho bot tiện ích, không phải nhập vai.",
        "loreSelective": "Nếu chế độ Chọn lọc được bật, cả Khóa kích hoạt và Khóa phụ phải khớp nhau để kích hoạt truyền thuyết.",
        "loreRandomActivation": "Nếu Điều kiện Xác suất Sử dụng được kích hoạt, nếu tất cả các điều kiện khác của truyền thuyết đều được đáp ứng, truyền thuyết sẽ được kích hoạt với một xác suất đã đặt được đặt bởi 'Xác suất' mỗi lần trò chuyện được gửi.",
        "additionalAssets": "Nội dung bổ sung để hiển thị trong cuộc trò chuyện của bạn.\n\n - sử dụng `{{raw::<asset name>}}` để dùng làm đường dẫn.\n - sử dụng `{{img::<asset name>}}` để sử dụng làm hình ảnh\n - sử dụng `{{video::<asset name>}}` để sử dụng làm video\n - sử dụng `{{audio::<asset name>}}` để sử dụng làm âm thanh\n    - nên đặt HTML nền",
        "superMemory": "SuperMemory giúp nhân vật của bạn ghi nhớ nhiều hơn bằng cách cung cấp dữ liệu tóm tắt cho AI.\n\nMô hình SuperMemory là mô hình tóm tắt văn bản đó. davinci được khuyến nghị và các mô hình phụ trợ không được khuyến nghị trừ khi đó là mô hình chưa được lọc với hơn 2000 mã thông báo có kỹ năng tóm tắt tuyệt vời.\n\nLời nhắc SuperMemory quyết định lời nhắc nào sẽ được gửi để tóm tắt. nếu bạn để trống, nó sẽ sử dụng lời nhắc mặc định. nên để trống.\n\nSau khi thiết lập xong, bạn có thể sử dụng nó trong cài đặt của một nhân vật.",
        "replaceGlobalNote": "Nếu nó không trống, nó sẽ thay thế ghi chú chung hiện tại bằng ghi chú này.",
        "backgroundHTML": "Dữ liệu Markdown/HTML sẽ được đưa vào nền màn hình trò chuyện.\n\n bạn cũng có thể sử dụng tài sản bổ sung. ví dụ: bạn có thể sử dụng `{{audio::<asset name}}` cho nhạc nền.\n\n Ngoài ra, bạn có thể sử dụng những thứ này với các nội dung bổ sung:\n - `{{bg::<asset name>}}`: thêm nền làm nội dung",
        "additionalText": "Văn bản sẽ được thêm vào Mô tả nhân vật chỉ khi AI cho rằng cần thiết, vì vậy bạn có thể đặt văn bản dài ở đây. Phân tách bằng hai dòng mới.",
        "charjs": "Mã javascript sẽ chạy cùng với nhân vật. Ví dụ, bạn có thể kiểm tra `https://github.com/kwaroran/Risuai/blob/main/src/etc/example-char.js`. HIỆN TẠI KHÔNG ĐƯỢC KHUYẾN NGHỊ SỬ DỤNG VÌ LÝ DO BẢO MẬT. VIỆC XUẤT SẼ KHÔNG BAO GỒM MÃ NÀY.",
        "romanizer": "Romanizer là một plugin chuyển đổi các ký tự không phải la tinh sang ký tự la tinh để giảm token khi sử dụng các ký tự không phải la tinh trong khi yêu cầu dữ liệu. Điều này có thể dẫn đến kết quả khác với mô hình gốc. Không nên sử dụng plugin này khi sử dụng các ký tự la tinh trong cuộc trò chuyện.",
        "inlayImages": "Nếu được bật, hình ảnh có thể được chèn vào cuộc trò chuyện và AI có thể nhìn thấy nó nếu chúng hỗ trợ.",
        "metrica": "Metric Systemizer là plugin chuyển đổi hệ mét sang hệ đo lường Anh khi yêu cầu và ngược lại khi xuất ra để hiển thị hệ mét cho người dùng trong khi sử dụng hệ đo lường Anh để tăng hiệu suất. Không nên sử dụng plugin này khi sử dụng hệ đo lường Anh trong cuộc trò chuyện.",
        "lorePlus": "LoreBook+ là tính năng thử nghiệm sử dụng vectordb thay vì chỉ khớp chuỗi để có trải nghiệm tạo bot tốt hơn và hiệu suất khớp tốt hơn.",
        "topP": "Top P là ngưỡng xác suất cho việc lấy mẫu hạt nhân. Mô hình xem xét kết quả của các token với khối lượng xác suất top_p.",
        "openAIFixer": "OpenAI Fixer là một plugin khắc phục một số vấn đề của OpenAI.",
        "sayNothing": "Nếu được bật, nó sẽ nhập 'say nothing' khi không có chuỗi nào được nhập.",
        "showUnrecommended": "Nếu được bật, nó sẽ hiển thị các cài đặt không được khuyến nghị, không còn được dùng nữa. KHÔNG KHUYẾN NGHỊ sử dụng các cài đặt này.",
        "streamingDisplayOptimizationMode": "Giảm giật lag khi stream phản hồi dài trong các trường hợp có nhiều hậu xử lý, chẳng hạn script dùng regex. Tùy chọn này có thể hữu ích trên thiết bị di động hoặc máy cấu hình thấp.\n\nTắt giữ hành vi bình thường, nhưng hậu xử lý chạy sau mỗi token và có thể tạo chi phí đáng kể.\n\nCân bằng giảm tải bằng cách chỉ thử hậu xử lý theo khoảng ngắn, khoảng 0,125 giây một lần.\n\nMạnh tương tự Cân bằng, nhưng bỏ qua hậu xử lý trong lúc stream và chỉ thử hậu xử lý một lần sau khi stream hoàn tất.\n\nĐây là tính năng thử nghiệm, nên một số tính năng có thể hoạt động ngoài ý muốn.",
        "imageCompression": "Nếu được bật, nó sẽ nén hình ảnh khi xuất nhân vật. Nếu hình ảnh động không hoạt động, hãy thử tắt tùy chọn này.",
        "useExperimental": "Nếu được bật, nó sẽ hiển thị một số tính năng thử nghiệm.",
        "forceProxyAsOpenAI": "Nếu được bật, nó sẽ buộc sử dụng định dạng OpenAI khi sử dụng proxy ngược.",
        "forcePlainFetch": "Nếu được bật, nó sẽ sử dụng api fetch của trình duyệt thay vì yêu cầu http gốc. Điều này có thể gây ra lỗi CORS.",
        "autoFillRequestURL": "Nếu được bật, nó sẽ tự động điền url yêu cầu để khớp với mô hình hiện tại.",
        "chainOfThought": "Nếu được bật, nó sẽ thêm lời nhắc chuỗi suy nghĩ vào lời nhắc.",
        "gptVisionQuality": "Tùy chọn này được sử dụng để đặt chất lượng của mô hình phát hiện hình ảnh. Chất lượng càng cao thì khả năng phát hiện càng chính xác nhưng sẽ sử dụng nhiều token hơn.",
        "genTimes": "Tùy chọn này được sử dụng để đặt số lượng phản hồi cần tạo trên các mô hình hỗ trợ. Ngoài phản hồi đầu tiên, các phản hồi khác sẽ hoạt động như reroll được lưu trong bộ nhớ đệm. Điều này có thể làm giảm chi phí của mô hình, nhưng cũng có thể làm tăng chi phí nếu bạn sử dụng nó mà không có reroll.",
        "requestretrys": "Tùy chọn này được sử dụng để đặt số lần thử lại yêu cầu khi yêu cầu thất bại.",
        "chatLoadInitialPages": "Số tin nhắn trò chuyện gần đây được hiển thị khi mở màn hình trò chuyện. Giá trị cao hơn hiển thị thêm lịch sử ngay lập tức nhưng có thể làm chat dài mở nặng hơn.",
        "chatLoadAdditionalPages": "Số tin nhắn cũ được hiển thị thêm mỗi khi bạn cuộn lên đầu. Giá trị cao hơn giảm số lần tải lặp lại nhưng mỗi lần tải có thể nặng hơn.",
        "emotionPrompt": "Tùy chọn này được sử dụng để đặt lời nhắc được sử dụng để phát hiện cảm xúc. Nếu để trống, nó sẽ sử dụng lời nhắc mặc định.",
        "removePunctuationHypa": "Nếu được bật, nó sẽ xóa dấu câu trước khi thực thi HypaMemory.",
        "additionalParams": "Các tham số bổ sung sẽ được thêm vào phần thân yêu cầu. Nếu bạn muốn loại trừ một số tham số, bạn có thể đặt `{{none}}` vào giá trị. Nếu bạn muốn thêm tiêu đề thay vì phần thân, bạn có thể đặt `header::` ở trước khóa như `header::Authorization`. Nếu bạn muốn giá trị ở dạng json, bạn có thể đặt `json::` ở trước giá trị như `json::{\"key\":\"value\"}`. Nếu không, loại giá trị sẽ được xác định tự động.",
        "antiClaudeOverload": "Nếu xảy ra quá tải Claude, Risuai sẽ cố gắng ngăn chặn bằng cách tiếp tục với cùng một lời nhắc, giúp giảm khả năng xảy ra lỗi. Chỉ hoạt động với các phản hồi được truyền trực tuyến. Điều này có thể không hoạt động đối với các điểm cuối api không chính thức.",
        "triggerScript": "Trigger Script là tập lệnh tùy chỉnh chạy khi điều kiện được đáp ứng. Nó có thể được sử dụng để sửa đổi dữ liệu trò chuyện, chạy lệnh, thay đổi biến, v.v. Loại kích hoạt phụ thuộc vào thời điểm kích hoạt. Nó cũng có thể được chạy bằng các nút, có thể được sử dụng với {{button::Display::TriggerName}} hoặc các nút HTML có thuộc tính `risu-trigger=\"<TriggerName>\"`.",
        "autoContinueChat": "Nếu được bật, nó sẽ cố gắng tiếp tục cuộc trò chuyện nếu nó không kết thúc bằng dấu câu. KHÔNG SỬ DỤNG TÍNH NĂNG NÀY VỚI CÁC NGÔN NGỮ KHÔNG SỬ DỤNG DẤU CÂU.",
        "combineTranslation": "Nếu được bật, văn bản là một câu nhưng bị tách bởi các thẻ HTML sẽ được kết hợp lại và dịch, sau đó tập lệnh Sửa đổi hiển thị sẽ được áp dụng lại cho đầu ra đã dịch.\nĐiều này giúp trình dịch thực hiện bản dịch chính xác.\nNếu giao diện người dùng trở nên kỳ lạ khi bạn bật tùy chọn này, hãy tắt tùy chọn và báo cáo.",
        "dynamicAssets": "Nếu được bật, nếu tên tài sản không được tìm thấy khi xử lý dữ liệu, nó sẽ cố gắng tìm tên tài sản gần nhất bằng cách sử dụng tìm kiếm vector và thay thế nó bằng tên tài sản gần nhất.",
        "dynamicAssetsEditDisplay": "Nếu được bật, tài sản động cũng sẽ được áp dụng cho giai đoạn Sửa đổi hiển thị. Tuy nhiên, điều này có thể gây ra vấn đề về hiệu suất.",
        "nickname": "Biệt danh sẽ được sử dụng trong {{char}} hoặc <char> trong cuộc trò chuyện thay vì tên nhân vật nếu được đặt.",
        "useRegexLorebook": "Nếu được bật, nó sẽ sử dụng regex để tìm kiếm lorebook, thay vì khớp chuỗi. Nó sử dụng định dạng /regex/flags.",
        "customChainOfThought": "Cảnh báo: chuyển đổi chuỗi suy nghĩ không còn được khuyến nghị sử dụng. Hãy đặt lời nhắc chuỗi suy nghĩ vào các mục lời nhắc khác.",
        "customPromptTemplateToggle": "Tại đây bạn có thể xác định các chuyển đổi lời nhắc của riêng mình. Sử dụng định dạng `<biến chuyển đổi>=<tên chuyển đổi>`, phân tách bằng dòng mới. Ví dụ, `cot=Bật/tắt COT`. Bạn có thể sử dụng các chuyển đổi này trong lời nhắc bằng cách sử dụng `{{getglobalvar::toggle_<biến chuyển đổi>}}`. Chẳng hạn như `{{getglobalvar::toggle_cot}}`.",
        "defaultVariables": "Tại đây bạn có thể xác định các biến mặc định của riêng mình. Sử dụng định dạng `<tên biến>=<giá trị biến>`, phân tách bằng dòng mới. Ví dụ, `name=Risuai`, sau đó có thể được sử dụng với các tập lệnh kích hoạt và biến CBS như `{{getvar::A}}`, `{{setvar::A::B}}` hoặc `{{? $A + 1}}`. Nếu biến mặc định của mẫu lời nhắc và biến mặc định của nhân vật có cùng tên, biến mặc định của nhân vật sẽ được sử dụng.",
        "lowLevelAccess": "Nếu được bật, nó sẽ cho phép truy cập vào các tính năng yêu cầu sức mạnh tính toán cao và thực thi mô hình AI thông qua các trình kích hoạt trong nhân vật. Đừng bật tính năng này trừ khi bạn thực sự cần các tính năng này.",
        "triggerLLMPrompt": "Lời nhắc sẽ được gửi đến mô hình. Bạn có thể sử dụng nhiều lượt và vai trò bằng cách sử dụng `@@role user`, `@@role system`, `@@role assistant`. Ví dụ, \n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation": "Nếu được bật, nó sẽ sử dụng phương pháp dịch cũ, xử lý trước markdown và dấu ngoặc kép trước khi dịch thay vì xử lý sau khi dịch.",
        "luaHelp": "Bạn có thể sử dụng tập lệnh Lua làm tập lệnh kích hoạt. Bạn có thể xác định các hàm onInput, onOutput, onStart. onInput được gọi khi người dùng gửi tin nhắn, onOutput được gọi khi nhân vật gửi tin nhắn, onStart được gọi khi cuộc trò chuyện bắt đầu. Để biết thêm thông tin, xem tài liệu.",
        "openAIFlexProcessing": "Phản hồi OpenAI Flex có thể chậm hơn phản hồi thông thường, nhưng có giá rẻ hơn (giá Batch API). Công tắc này chỉ áp dụng cho yêu cầu OpenAI Chat Completions chính thức.",
        "claudeCachingExperimental": "Lưu trữ đệm trong Claude là tính năng thử nghiệm có thể giảm chi phí mô hình, nhưng cũng có thể tăng chi phí nếu bạn sử dụng nó mà không có reroll. Vì đây là tính năng thử nghiệm, nó có thể không ổn định và hành vi có thể thay đổi trong tương lai.",
        "urllora": "Bạn có thể sử dụng liên kết tải xuống trực tiếp của tệp mô hình. Bạn có thể tạo url trực tiếp từ google drive như trang web https://sites.google.com/site/gdocs2direct/, hoặc sử dụng URL civitai, sao chép AIR (trông giống như `urn:air:flux1:lora:civitai:180891@776656` hoặc chỉ `civitai:180891@776656`) và dán vào.",
        "v2GetAlertSelect": "Các tùy chọn được phân tách bằng ký tự | (pipe).",
        "v2RegexTest": "Trả về 1 nếu regex khớp, 0 nếu không khớp.",
        "v2Calculate": "Đánh giá các biểu thức toán học với hỗ trợ cho số học cơ bản (+, -, *, /, %, ^), toán tử so sánh (<, >, <=, >=, =, !=), toán tử logic (&&, ||, !), dấu ngoặc đơn để ưu tiên, và thay thế biến bằng định dạng $variableName. Các biến được tự động chuyển đổi thành số (mặc định là 0 nếu không hợp lệ).",
        "namespace": "Namespace là một định danh duy nhất cho mô-đun. Nó được sử dụng để ngăn xung đột giữa các mô-đun, và cho sự tương tác của các cài đặt trước, các mô-đun khác, v.v. Nếu bạn không chắc chắn nên đặt gì, hãy để trống.",
        "moduleIntergration": "Bạn có thể kích hoạt các mô-đun bằng cách đặt namespace mô-đun vào phần tích hợp mô-đun. Nếu bạn muốn kích hoạt nhiều mô-đun, bạn có thể phân tách chúng bằng dấu phẩy. Ví dụ, `module1,module2,module3`. Điều này dành cho người dùng nâng cao, những người muốn thay đổi việc sử dụng các mô-đun theo cài đặt trước.",
        "customCSS": "CSS tùy chỉnh để tạo kiểu. Bạn cũng có thể tắt/bật nó bằng cách nhấn (Ctrl + .) nếu có sự cố.",
        "betaMobileGUI": "Nếu được bật, nó sẽ sử dụng GUI di động beta trên màn hình nhỏ (nhỏ hơn 800px). Cần làm mới.",
        "unrecommended": "Đây là cài đặt không được khuyến nghị. Không nên sử dụng cài đặt này.",
        "jsonSchema": "Đây là JSON Schema sẽ được gửi đến mô hình AI nếu mô hình AI hỗ trợ JSON Schema.\n\nTuy nhiên, vì JSON Schema khó học, trong Risuai, bạn có thể sử dụng tập hợp con của giao diện TypeScript thay vì JSON Schema. Risuai sẽ chuyển đổi nó trong thời gian chạy. Ví dụ, nếu bạn muốn gửi một JSON như thế này:\n\n```js\n{\n  \"name\": \"Risuai\", //tên phải là Risuai,\n  \"age\": 1, //tuổi phải là số,\n  \"icon\": \"slim\", //biểu tượng phải là 'slim' hoặc 'rounded'\n  \"thoughts\": [\"Good View!\", \"Lorem\"] //suy nghĩ phải là mảng chuỗi\n}\n```\n\nBạn có thể đặt giao diện TypeScript này:\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: 'slim'|'rounded'\n  thoughts: string[]\n}\n```\n\nTên của giao diện không quan trọng. Để biết thêm thông tin, xem tài liệu typescript. (https://www.typescriptlang.org/docs/handbook/interfaces.html), và để kiểm tra tập hợp con nào của TypeScript được hỗ trợ, hãy xem bên dưới.<details><summary>Tập hợp con TypeScript được hỗ trợ</summary>\n\nCác loại được hỗ trợ là `boolean`, `number`, `string`, `Array`. Các kiểu nâng cao như kiểu đơn vị, kiểu giao nhau, kiểu hợp, tùy chọn, kiểu chữ, v.v. không được hỗ trợ ngoại trừ các trường hợp sau:\n\n        - Mảng các kiểu nguyên thủy: (ví dụ: `string[]`, `Array<boolean>)`\n        - Kiểu đơn vị giữa các chuỗi: (ví dụ: `'slim'|'rounded'`).\n\n        Các thuộc tính phải nằm trên một dòng. Nếu có nhiều thuộc tính trên một dòng, nó sẽ báo lỗi. Thuộc tính và tên của giao diện chỉ được dùng các ký tự latin, trong phạm vi ASCII. Tên của các thuộc tính không được bao quanh bởi dấu ngoặc đơn hoặc dấu ngoặc kép. Lồng nhau bên trong giao diện không được hỗ trợ. Không được phép đặt `{` hoặc `}` trong dòng mà các thuộc tính được xác định. Nếu bạn muốn sử dụng các kiểu nâng cao hơn, hãy sử dụng JSON Schema thay thế.\n        </details>",
        "strictJsonSchema": "Nếu được bật, nó sẽ tuân thủ nghiêm ngặt Schema được cung cấp cho JSON trên một số mô hình. Nếu tắt, nó có thể bỏ qua JSON Schema.",
        "extractJson": "Nếu không trống, nó sẽ trích xuất dữ liệu JSON cụ thể từ phản hồi. Ví dụ, nếu bạn muốn trích xuất `response.text[0]` trong phản hồi `{\"response\": {\"text\": [\"hello\"]}}`, bạn có thể đặt `response.text.0`.",
        "translatorNote": "Tại đây, bạn có thể thêm lời nhắc dịch duy nhất cho mỗi nhân vật. Tùy chọn này chỉ áp dụng khi sử dụng mô hình Ax. để dịch. Để áp dụng, bao gồm `{{slot::tnote}}` trong cài đặt ngôn ngữ. Nó không hoạt động trong các cuộc trò chuyện nhóm.",
        "groupInnerFormat": "Điều này xác định định dạng được sử dụng trong trò chuyện nhóm cho các nhân vật không phải là người nói. Nếu không trống, nó sẽ sử dụng định dạng này thay vì định dạng mặc định. Nếu `Vai trò Bot Khác trong Nhóm` là `assistant`, nó cũng sẽ được áp dụng cho người nói.",
        "groupOtherBotRole": "Điều này xác định vai trò được sử dụng trong trò chuyện nhóm cho các nhân vật không phải là người nói.",
        "chatHTML": "HTML sẽ được chèn vào mỗi cuộc trò chuyện.\n\nBạn có thể sử dụng CBS và các thẻ đặc biệt.\n- `<risutextbox>`: hộp văn bản sẽ được sử dụng để hiển thị văn bản\n- `<risuicon>`: biểu tượng cho người dùng hoặc trợ lý\n- `<risubuttons>`: các nút biểu tượng để chỉnh sửa trò chuyện, dịch thuật, v.v.\n- `<risugeninfo>`: nút thông tin tạo.",
        "systemContentReplacement": "Định dạng lời nhắc thay thế lời nhắc hệ thống nếu mô hình không hỗ trợ lời nhắc hệ thống.",
        "systemRoleReplacement": "Vai trò thay thế vai trò hệ thống nếu mô hình không hỗ trợ vai trò hệ thống.",
        "summarizationPrompt": "Lời nhắc được sử dụng để tóm tắt. Nếu để trống, nó sẽ sử dụng lời nhắc mặc định. Bạn cũng có thể sử dụng định dạng ChatML với {{slot}} cho dữ liệu trò chuyện.",
        "translatorPrompt": "Lời nhắc được sử dụng để dịch. Nếu để trống, nó sẽ sử dụng lời nhắc mặc định. Bạn cũng có thể sử dụng định dạng ChatML với {{slot}} cho ngôn ngữ đích, {{solt::content}} cho nội dung, và {{slot::tnote}} cho ghi chú của người dịch.",
        "translateBeforeHTMLFormatting": "Nếu được bật, nó sẽ dịch văn bản trước các tập lệnh Regex và định dạng HTML. Điều này có thể làm giảm token nhưng có thể phá vỡ định dạng.",
        "autoTranslateCachedOnly": "Nếu được bật cùng với tùy chọn Tự động dịch, nó sẽ tự động dịch chỉ những tin nhắn mà người dùng đã dịch trước đó.",
        "presetChain": "Nếu không trống, cài đặt trước sẽ được thay đổi và áp dụng ngẫu nhiên mỗi khi người dùng gửi tin nhắn trong danh sách cài đặt trước ở đầu vào này. Danh sách cài đặt trước nên được phân tách bằng dấu phẩy, ví dụ, `preset1,preset2`.",
        "legacyMediaFindings": "Nếu được bật, nó sẽ sử dụng phương pháp cũ để tìm tài sản phương tiện, mà không sử dụng thuật toán tìm kiếm bổ sung.",
        "comfyWorkflow": "Đặt luồng công việc API của Comfy UI. Bạn có thể lấy luồng công việc API trong Comfy UI bằng cách nhấn nút 'Workflow > Export (API)'. Bạn cũng phải đặt {{risu_prompt}} trong văn bản luồng công việc của mình. {{risu_prompt}} sẽ được thay thế bằng lời nhắc do Risu cung cấp.",
        "automaticCachePoint": "Tự động tạo điểm lưu trữ sau khi cuộc trò chuyện kết thúc, nếu điểm lưu trữ chưa tồn tại.",
        "experimentalChatCompressionDesc": "Nén dữ liệu trò chuyện không sử dụng và lưu vào tệp riêng biệt. Điều này làm giảm đáng kể kích thước dữ liệu trò chuyện và cải thiện đáng kể hiệu suất, tuy nhiên đây là tính năng thử nghiệm và có thể không ổn định, gây ra sự cố trong tính năng sao lưu và hơn thế nữa.",
        "promptInfoInsideChatDesc": "Khi được bật, tính năng này lưu trữ thông tin cài đặt trước lời nhắc trong siêu dữ liệu trò chuyện. Dữ liệu được lưu trữ bao gồm tên cài đặt trước, các chuyển đổi đang hoạt động và văn bản lời nhắc. Điều này có thể làm tăng nhẹ thời gian xử lý và dung lượng lưu trữ.",
        "autoAdjustSchema": "Khi được bật, nó sẽ tự động điều chỉnh JSON schema cho Đầu ra Động.",
        "dynamicMessages": "Khi được bật, nó sẽ cho phép trợ lý gửi nhiều tin nhắn liên tiếp, thay vì từng tin nhắn một.",
        "dynamicMemory": "Khi được bật, trợ lý sẽ ghi chú bộ nhớ vào thời gian phản hồi. Cần có thêm lời nhắc để sử dụng tính năng này.",
        "dynamicResponseTiming": "Khi được bật, nó sẽ điều chỉnh thời gian phản hồi một cách linh hoạt.",
        "dynamicRequest": "Khi được bật, nó sẽ yêu cầu mô hình vào thời điểm ngẫu nhiên mà không cần chờ người dùng nhập liệu.",
        "settingsCloseButtonSize": "Điều chỉnh kích thước nút đóng (X) ở góc trên bên phải cửa sổ cài đặt. Mặc định là 24.",
        "showTypingEffect": "Khi được bật, nó sẽ hiển thị chỉ báo đang nhập trong khi trợ lý đang tạo phản hồi.",
        "dynamicOutputPrompt": "Khi được bật, thông tin lược đồ sẽ được bao gồm trong yêu cầu.",
        "realmDirectOpen": "Nếu được bật, nhấp vào một nhân vật trong bản xem trước RisuRealm sẽ mở trực tiếp mô tả nhân vật.",
        "openRouterProviderOrder": "Thứ tự các nhà cung cấp được sử dụng, nhà cung cấp đầu tiên sẽ được sử dụng trước, nếu nhà cung cấp không có sẵn, nó sẽ sử dụng nhà cung cấp tiếp theo. Xem chi tiết tại https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers",
        "openRouterProviderOnly": "Chỉ sử dụng các nhà cung cấp trong danh sách này, nếu tất cả các nhà cung cấp không có sẵn, yêu cầu sẽ thất bại. Xem chi tiết tại https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers",
        "openRouterProviderIgnore": "Bỏ qua các nhà cung cấp trong danh sách này, nếu tất cả các nhà cung cấp bị bỏ qua, yêu cầu sẽ thất bại. Xem chi tiết tại https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers",
        "additionalPrompt": "Văn bản được thêm vào cuối Lời nhắc chính khi Tiền xử lý lời nhắc được bật. Mặc định là 'The assistant must act as {{char}}. user is {{user}}.' Điều này giúp thiết lập ngữ cảnh nhập vai cơ bản.",
        "hideAllImagesDesc": "Ẩn biểu tượng bot, tài nguyên hình ảnh bot và ảnh bìa RisuRealm.",
        "embedding": "Mô hình nhúng được sử dụng cho tìm kiếm tương đồng trên nhiều tính năng:\n\n- **Bộ nhớ dài hạn**: HypaV2, HypaV3, Bộ nhớ Hanurai và SupaMemory (khi bật HypaMemory)\n- **Văn bản bổ sung**: Khớp thông tin bổ sung của nhân vật dựa trên ngữ cảnh\n- **Tài sản động**: Tìm tên tài sản tương tự khi không tìm thấy kết quả khớp chính xác\n- **Hình ảnh cảm xúc**: Khi phương pháp Cảm xúc được đặt thành 'embedding'\n- **Tập lệnh kích hoạt**: Các điều kiện tương đồng trong tập lệnh kích hoạt\n- **Tệp đính kèm**: Tìm kiếm trong các tệp đính kèm PDF/TXT/XML\n- **Playground**: Thử nghiệm nhúng trong Playground",
        "keepSessionAlive": "Giữ tab luôn hoạt động và ngăn phiên hết hạn do không hoạt động trên trình duyệt. Có thể cần tải lại trang để có hiệu lực.\n\n- **Qua âm thanh**: Phát lặp một âm tần số thấp không nghe thấy được để duy trì phiên. Phương pháp này được biết đến là tương thích và hiệu quả nhất trên hầu hết các trình duyệt. Trên Android, một thông báo phương tiện sẽ hiển thị khi tính năng đang hoạt động và các ứng dụng nghe nhạc khác có thể bị tạm dừng.\n",
        "enableScrollToActiveChar": "Nếu được bật, nhấn phím tắt hoặc giữ phím Ctrl khi kéo một nhân vật sẽ cuộn đến nhân vật hiện đang hoạt động. Các thư mục sẽ tự động được mở nếu đang đóng."
    },
    "setup": {
        "chooseProvider": "Chọn nhà cung cấp AI",
        "openaikey": "OpenAI với Khóa API (Được khuyến nghị)",
        "openaiProxy": "Proxy ngược OpenAI",
        "setupmodelself": "Người khác/Tôi sẽ tự thiết lập",
        "inputApiKey": "Nhập khóa API tại đây",
        "apiKeyhelp": "Bạn có thể lấy khóa api từ:",
        "setupSelfHelp": "Tự thiết lập trong cài đặt, sau khi màn hình Chào mừng kết thúc.",
        "theme": "Chọn chủ đề của bạn",
        "themeDescWifulike": "Không phù hợp với di động",
        "themeDescWifuCut": "Thích hợp cho di động",
        "themeDescClassic": "Thích hợp cho mọi thiết bị",
        "texttheme": "Chọn màu văn bản của bạn",
        "inputName": "Cuối cùng, nhập Biệt hiệu của bạn.",
        "welcome": "Chào mừng đến với Risuai! Tôi là Airisu, tôi ở đây để hướng dẫn bạn cài đặt Risuai. Trước tiên, tôi có thể gọi bạn là gì?",
        "welcome2": "Xin chào {username}! Trước khi bắt đầu, tôi sẽ hỏi bạn một số câu hỏi. Bạn có thể thay đổi các cài đặt này sau trong phần cài đặt.\n\nĐầu tiên hãy chọn nhà cung cấp AI.",
        "openRouterProvider": "OpenRouter có rất nhiều mô hình, một số không được lọc và một số miễn phí, nhưng nó không tốt bằng OpenAI.",
        "hordeProvider": "Horde là nhà cung cấp miễn phí, nhưng thời gian phản hồi lâu và chất lượng thấp.",
        "setProviderLater": "Có các nhà cung cấp khác, nhưng bạn có thể cài đặt sau trong phần cài đặt. Chọn mục này nếu bạn muốn cài đặt sau.",
        "setupOpenAI": "Để sử dụng OpenAI, bạn cần lấy khóa API. \n1. đi tới https://beta.openai.com/ \n2. đăng nhập bằng tài khoản của bạn \n3. đi tới https://beta.openai.com/account/api-keys \n4. nhấp vào 'Create New API Key' và đặt tên cho khóa của bạn bất cứ điều gì bạn muốn. \n5. sao chép khóa trên trang web.\n6. quay lại Risuai\n7. dán nó và nhấp vào nút gửi.",
        "setupClaude": "Để sử dụng Claude, bạn cần lấy khóa API.",
        "setupClaudeSteps": [
            "Truy cập URL này và Đăng nhập bằng Google",
            "Nhập thông tin của bạn và nhấp vào 'Continue'",
            "Trên trang tổ chức, chỉ cần nhập bất kỳ tên nào vào ô đầu tiên và nhấp vào 'Create Account'",
            "Nhấn nút 'Buy Credits'",
            "Nhấn nút 'Complete Setup'",
            "Nhập giống như hình trên, ngoại trừ phần quốc gia, bạn cần nhập quốc gia của mình. sau đó nhấn 'Continue'",
            "Thêm phương thức thanh toán của bạn và nhấn 'Continue'",
            "Sau khi thanh toán đã được đăng ký, nhấn 'Add Funds' và thêm tiền. bạn có thể thêm tối thiểu 5$ hoặc bạn có thể thiết lập tự động nạp tiền.",
            "Sau khi thêm tiền, hãy chuyển đến trang tổng quan và nhấn nút 'Get API Keys'",
            "Nhấn nút \"Create API Key\"",
            "Nhập giống như hình trên và nhấn 'Add'",
            "Sao chép khóa và dán vào đây và gửi đi."
        ],
        "setupOpenRouter": "Để sử dụng OpenRouter, bạn cần lấy khóa API. \n1. đi tới https://openrouter.ai/keys\n2. nhấp vào 'Create Key'\n3. đặt tên khóa bất cứ điều gì bạn muốn.\n4. sao chép khóa trên trang web\n5. quay lại Risuai\n6. dán nó và nhấp vào nút gửi.",
        "allDone": "Xong tất cả! vui lòng đợi một chút.",
        "welcomeTitleName": "Mình nên gọi bạn là gì?",
        "welcomeTitleGuide": "Bạn có muốn mình hướng dẫn cài đặt không?",
        "welcomeTitleProvider": "Chọn nhà cung cấp AI",
        "welcomeTitleApiKey": "Dán khóa API của bạn",
        "welcomeTitleChatLang": "Chọn ngôn ngữ trò chuyện",
        "welcomeTitleMemory": "Trí nhớ hay chi phí?",
        "welcomeTitleDone": "Đã xong!",
        "welcomeChangeLater": "Bạn có thể thay đổi tất cả sau trong phần cài đặt.",
        "welcomeContinue": "Tiếp tục",
        "setupLaterMessage": "Chào mừng {username}! bạn muốn tôi hướng dẫn cài đặt hay tự làm?",
        "setupMessageOption1": "Hướng dẫn tôi cài đặt",
        "setupMessageOption1Desc": "Khuyên dùng cho người dùng mới",
        "setupMessageOption2": "Tôi sẽ tự cài đặt",
        "claudeDesc": "Claude là mô hình AI được tạo bởi Anthropic, đối thủ cạnh tranh của OpenAI. Nó tốt hơn GPT nếu bạn muốn sử dụng bằng các ngôn ngữ khác ngoài tiếng Anh.",
        "openAIDesc": "OpenAI GPT là mô hình AI chất lượng cao, nhưng phải trả phí và được lọc, và yếu ở các ngôn ngữ khác ngoài tiếng Anh.",
        "chooseChatType": "Tuyệt vời! Bây giờ hãy chọn ngôn ngữ trò chuyện.",
        "chooseChatTypeOption1": "Hoàn toàn tiếng Anh",
        "chooseChatTypeOption1Desc": "Điều này sẽ khiến AI sử dụng tiếng Anh và nhập/xuất bằng tiếng Anh. Khuyên dùng cho người nói tiếng Anh.",
        "chooseChatTypeOption2": "Xử lý bằng tiếng Anh",
        "chooseChatTypeOption2Desc": "Điều này sẽ khiến AI sử dụng tiếng Anh nội bộ, nhưng đầu vào/đầu ra sẽ bằng ngôn ngữ của bạn. Được đề xuất cho người không nói tiếng Anh.",
        "chooseChatTypeOption3": "Không tập trung vào ngôn ngữ",
        "chooseChatTypeOption3Desc": "Điều này sẽ khiến AI sử dụng ngôn ngữ của bạn nội bộ, nhưng có thể làm giảm chất lượng.",
        "chooseCheapOrMemory": "Nhân tiện, bạn thích bộ nhớ hay giá rẻ hơn?",
        "chooseCheapOrMemoryOption1": "Bộ nhớ",
        "chooseCheapOrMemoryOption1Desc": "Điều này sẽ khiến AI ghi nhớ nhiều hơn, nhưng sẽ khá đắt.",
        "chooseCheapOrMemoryOption2": "Giá rẻ",
        "chooseCheapOrMemoryOption2Desc": "Điều này sẽ khiến AI ghi nhớ ít hơn, nhưng sẽ rẻ hơn.",
        "chooseCheapOrMemoryOption3": "Cân bằng",
        "chooseCheapOrMemoryOption3Desc": "Điều này sẽ khiến AI ghi nhớ nhiều hơn giá rẻ, nhưng ít hơn bộ nhớ.",
        "chooseCheapOrMemoryOption4": "Không giới hạn",
        "chooseCheapOrMemoryOption4Desc": "Điều này sẽ khiến AI ghi nhớ hầu hết mọi thứ, nhưng sẽ rất đắt.",
        "finally": "Cuối cùng, bạn có muốn bật các công cụ nâng cao không?",
        "finallyOption1": "Có",
        "finallyOption1Desc": "Điều này sẽ bật các công cụ nâng cao, nhưng sẽ làm cho giao diện người dùng phức tạp hơn. Khuyên dùng cho người dùng nâng cao.",
        "finallyOption2": "Không",
        "finallyOption2Desc": "Điều này sẽ tắt các công cụ nâng cao và làm cho giao diện người dùng đơn giản hơn. Khuyên dùng cho người dùng mới.",
        "igpPrompt": "Nếu IGP Prompt không trống, nó sẽ được thực thi sau yêu cầu mô hình chính, sau khi thực thi mô hình chính, dưới dạng mô hình cảm xúc, thêm kết quả sau phản hồi mô hình chính."
    },
    "triggerCategories": {
        "Special": "Đặc biệt",
        "Control": "Điều khiển",
        "Chat": "Trò chuyện",
        "Low Level": "Cấp thấp",
        "Alert": "Cảnh báo",
        "Lorebook V2": "Sách truyền thuyết V2",
        "String": "Chuỗi",
        "Data": "Dữ liệu",
        "Array": "Mảng",
        "Others": "Khác",
        "Deprecated": "Không dùng nữa"
    },
    "triggerDesc": {
        "v2Header": "Tiêu đề",
        "v2HeaderDesc": "Tiêu đề",
        "v2If": "Nếu",
        "v2IfDesc": "Nếu {{source}} {{condition}} {{target}}",
        "v2Else": "Ngược lại",
        "v2ElseDesc": "Ngược lại",
        "v2EndIndent": "Kết thúc thụt lề",
        "v2EndIndentDesc": "Kết thúc thụt lề",
        "v2SetVar": "Đặt biến",
        "v2SetVarDesc": "Đặt biến {{var}} {{operator}} {{value}}",
        "v2Loop": "Lặp lại mãi mãi",
        "v2LoopDesc": "Lặp lại mãi mãi",
        "v2BreakLoop": "Ngắt vòng lặp",
        "v2BreakLoopDesc": "Ngắt vòng lặp",
        "v2RunTrigger": "Chạy Trigger",
        "v2RunTriggerDesc": "Chạy Trigger {{target}}",
        "v2ConsoleLog": "Nhật ký Console",
        "v2ConsoleLogDesc": "Nhật ký Console {{source}}",
        "v2StopTrigger": "Dừng Trigger",
        "v2StopTriggerDesc": "Dừng Trigger",
        "v2CutChat": "Cắt trò chuyện",
        "v2CutChatDesc": "Cắt trò chuyện từ {{start}} đến {{end}}",
        "v2ModifyChat": "Sửa đổi trò chuyện",
        "v2ModifyChatDesc": "Sửa đổi trò chuyện tại chỉ số {{index}} với {{value}}",
        "v2SystemPrompt": "Thêm lời nhắc hệ thống",
        "v2SystemPromptDesc": "Thêm lời nhắc hệ thống tại {{location}} với {{value}}",
        "v2Impersonate": "Gửi trò chuyện",
        "v2ImpersonateDesc": "Gửi trò chuyện dưới dạng {{role}} với {{value}}",
        "v2Command": "Chạy lệnh",
        "v2CommandDesc": "Chạy lệnh với {{value}}",
        "v2SendAIprompt": "Gửi lời nhắc AI",
        "v2SendAIpromptDesc": "Gửi lời nhắc AI",
        "v2ImgGen": "Tạo hình ảnh",
        "v2ImgGenDesc": "Tạo hình ảnh từ {{value}}, phủ định từ {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "Kiểm tra độ tương đồng",
        "v2CheckSimilarityDesc": "Kiểm tra độ tương đồng giữa {{source}} và {{value}} => {{outputVar}}",
        "v2RunLLM": "Chạy mô hình",
        "v2RunLLMDesc": "Gửi yêu cầu đến mô hình từ {{value}} => {{outputVar}}",
        "v2ShowAlert": "Hiển thị cảnh báo",
        "v2ShowAlertDesc": "Hiển thị cảnh báo với {{value}}",
        "v2ExtractRegex": "Trích xuất Regex",
        "v2ExtractRegexDesc": "Trích xuất văn bản từ {{value}} bằng regex {{regexType}} {{regex}} và cờ {{flagsType}} {{flags}}, sau đó lưu kết quả dưới dạng {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "Kiểm tra Regex",
        "v2RegexTestDesc": "Kiểm tra {{value}} bằng regex {{regex}} và cờ {{flags}} => {{outputVar}}",
        "v2GetLastMessage": "Lấy tin nhắn cuối cùng",
        "v2GetLastMessageDesc": "Lấy tin nhắn cuối cùng => {{outputVar}}",
        "v2GetMessageAtIndex": "Lấy tin nhắn tại chỉ số",
        "v2GetMessageAtIndexDesc": "Lấy tin nhắn tại chỉ số {{index}} => {{outputVar}}",
        "v2GetMessageCount": "Lấy số lượng tin nhắn",
        "v2GetMessageCountDesc": "Lấy số lượng tin nhắn => {{outputVar}}",
        "v2GetLorebook": "Lấy Sách truyền thuyết",
        "v2GetLorebookDesc": "Lấy Sách truyền thuyết tên {{target}} => {{outputVar}}",
        "v2GetLorebookCount": "Lấy số lượng Sách truyền thuyết",
        "v2GetLorebookCountDesc": "Lấy số lượng Sách truyền thuyết => {{outputVar}}",
        "v2GetLorebookEntry": "Lấy Sách truyền thuyết với chỉ số",
        "v2GetLorebookEntryDesc": "Lấy Sách truyền thuyết với chỉ số {{index}} => {{outputVar}}",
        "v2SetLorebookActivation": "Đặt kích hoạt Sách truyền thuyết",
        "v2SetLorebookActivationDesc": "Đặt trạng thái kích hoạt của Sách truyền thuyết có chỉ số {{index}} thành {{value}}",
        "v2GetLorebookIndexViaName": "Lấy chỉ số Sách truyền thuyết qua Tên",
        "v2GetLorebookIndexViaNameDesc": "Lấy chỉ số Sách truyền thuyết qua Tên {{name}} => {{outputVar}}",
        "v2ModifyLorebook": "Sửa đổi Sách truyền thuyết",
        "v2ModifyLorebookDesc": "Sửa đổi Sách truyền thuyết tên {{target}} với {{value}}",
        "v2LoopNTimes": "Lặp lại N lần",
        "v2LoopNTimesDesc": "Lặp lại {{value}} lần",
        "v2Random": "Ngẫu nhiên",
        "v2RandomDesc": "Ngẫu nhiên từ {{min}} đến {{max}} => {{outputVar}}",
        "v2GetCharAt": "Lấy ký tự tại chỉ số",
        "v2GetCharAtDesc": "Lấy ký tự tại chỉ số {{index}} từ {{source}} => {{outputVar}}",
        "v2GetCharCount": "Lấy số lượng ký tự",
        "v2GetCharCountDesc": "Lấy số lượng ký tự từ {{source}} => {{outputVar}}",
        "v2ToLowerCase": "Chuyển thành chữ thường",
        "v2ToLowerCaseDesc": "Chuyển {{source}} thành chữ thường => {{outputVar}}",
        "v2ToUpperCase": "Chuyển thành chữ hoa",
        "v2ToUpperCaseDesc": "Chuyển {{source}} thành chữ hoa => {{outputVar}}",
        "v2SetCharAt": "Đặt ký tự tại chỉ số",
        "v2SetCharAtDesc": "Đặt ký tự tại chỉ số {{index}} trong {{source}} thành {{value}} => {{outputVar}}",
        "v2SplitString": "Tách chuỗi",
        "v2SplitStringDesc": "Tách {{source}} bằng {{delimiter}} => {{outputVar}}",
        "v2GetCharacterDesc": "Lấy mô tả nhân vật",
        "v2GetCharacterDescDesc": "Lấy mô tả nhân vật => {{outputVar}}",
        "v2SetCharacterDesc": "Đặt mô tả nhân vật",
        "v2SetCharacterDescDesc": "Đặt mô tả nhân vật thành {{value}}",
        "v2GetPersonaDesc": "Lấy lời nhắc Persona",
        "v2GetPersonaDescDesc": "Lấy lời nhắc Persona => {{outputVar}}",
        "v2SetPersonaDesc": "Đặt lời nhắc Persona",
        "v2SetPersonaDescDesc": "Đặt lời nhắc Persona thành {{value}}",
        "v2GetReplaceGlobalNote": "Lấy Ghi chú chung thay thế",
        "v2GetReplaceGlobalNoteDesc": "Lấy Ghi chú chung thay thế => {{outputVar}}",
        "v2SetReplaceGlobalNote": "Đặt Ghi chú chung thay thế",
        "v2SetReplaceGlobalNoteDesc": "Đặt Ghi chú chung thay thế thành {{value}}",
        "v2GetAuthorNote": "Lấy Ghi chú tác giả",
        "v2GetAuthorNoteDesc": "Lấy Ghi chú tác giả => {{outputVar}}",
        "v2SetAuthorNote": "Đặt Ghi chú tác giả",
        "v2SetAuthorNoteDesc": "Đặt Ghi chú tác giả thành {{value}}",
        "v2Comment": "Thêm bình luận",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "Khai báo biến cục bộ",
        "v2DeclareLocalVarDesc": "Khai báo biến cục bộ {{var}} với giá trị {{value}}",
        "v2MakeArrayVar": "Tạo biến mảng",
        "v2MakeArrayVarDesc": "Tạo biến mảng {{var}}",
        "v2GetArrayVarLength": "Lấy độ dài biến mảng",
        "v2GetArrayVarLengthDesc": "Lấy độ dài của biến mảng {{var}} => {{outputVar}}",
        "v2GetArrayVar": "Lấy biến mảng",
        "v2GetArrayVarDesc": "Lấy giá trị tại chỉ số {{index}} từ biến mảng {{var}} => {{outputVar}}",
        "v2SetArrayVar": "Đặt biến mảng",
        "v2SetArrayVarDesc": "Đặt giá trị tại chỉ số {{index}} trong biến mảng {{var}} thành {{value}}",
        "v2PushArrayVar": "Thêm vào biến mảng",
        "v2PushArrayVarDesc": "Thêm {{value}} vào biến mảng {{var}}",
        "v2PopArrayVar": "Xóa giá trị cuối cùng từ biến mảng và lấy",
        "v2PopArrayVarDesc": "Xóa giá trị cuối cùng từ biến mảng {{var}} => {{outputVar}}",
        "v2ShiftArrayVar": "Xóa giá trị đầu tiên từ biến mảng và lấy",
        "v2ShiftArrayVarDesc": "Xóa giá trị đầu tiên từ biến mảng {{var}} => {{outputVar}}",
        "v2UnshiftArrayVar": "Thêm vào biến mảng làm giá trị đầu tiên",
        "v2UnshiftArrayVarDesc": "Thêm {{value}} làm giá trị đầu tiên của biến mảng {{var}}",
        "v2SpliceArrayVar": "Thêm vào biến mảng tại chỉ số",
        "v2SpliceArrayVarDesc": "Thêm {{value}} làm giá trị {{start}} của biến mảng {{var}}",
        "v2SliceArrayVar": "Cắt biến mảng",
        "v2SliceArrayVarDesc": "Cắt biến mảng {{var}} từ {{start}} đến {{end}} => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "Lấy chỉ số của giá trị trong biến mảng",
        "v2GetIndexOfValueInArrayVarDesc": "Lấy chỉ số của {{value}} trong biến mảng {{var}} => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "Xóa chỉ số khỏi biến mảng",
        "v2RemoveIndexFromArrayVarDesc": "Xóa giá trị tại chỉ số {{index}} khỏi biến mảng {{var}}",
        "v2JoinArrayVar": "Nối mảng",
        "v2JoinArrayVarDesc": "Nối mảng {{var}} bằng {{delimiter}} => {{outputVar}}",
        "v2MakeDictVar": "Tạo biến từ điển",
        "v2MakeDictVarDesc": "Tạo biến từ điển {{var}}",
        "v2GetDictVar": "Lấy giá trị từ điển",
        "v2GetDictVarDesc": "Lấy giá trị cho khóa {{key}} từ từ điển {{var}} => {{outputVar}}",
        "v2SetDictVar": "Đặt giá trị từ điển",
        "v2SetDictVarDesc": "Đặt giá trị cho khóa {{key}} trong từ điển {{var}} thành {{value}}",
        "v2DeleteDictKey": "Xóa khóa từ điển",
        "v2DeleteDictKeyDesc": "Xóa khóa {{key}} khỏi từ điển {{var}}",
        "v2HasDictKey": "Có khóa từ điển",
        "v2HasDictKeyDesc": "Kiểm tra nếu từ điển {{var}} có khóa {{key}} => {{outputVar}}",
        "v2ClearDict": "Xóa từ điển",
        "v2ClearDictDesc": "Xóa từ điển {{var}}",
        "v2GetDictSize": "Lấy kích thước từ điển",
        "v2GetDictSizeDesc": "Lấy kích thước của từ điển {{var}} => {{outputVar}}",
        "v2GetDictKeys": "Lấy các khóa từ điển",
        "v2GetDictKeysDesc": "Lấy tất cả các khóa từ từ điển {{var}} => {{outputVar}}",
        "v2GetDictValues": "Lấy các giá trị từ điển",
        "v2GetDictValuesDesc": "Lấy tất cả các giá trị từ từ điển {{var}} => {{outputVar}}",
        "v2ConcatString": "Nối chuỗi",
        "v2ConcatStringDesc": "Nối {{source1}} và {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "Lấy tin nhắn người dùng cuối cùng",
        "v2GetLastUserMessageDesc": "Lấy tin nhắn người dùng cuối cùng => {{outputVar}}",
        "v2GetLastCharMessage": "Lấy tin nhắn nhân vật cuối cùng",
        "v2GetLastCharMessageDesc": "Lấy tin nhắn nhân vật cuối cùng => {{outputVar}}",
        "v2GetFirstMessage": "Lấy tin nhắn đầu tiên",
        "v2GetFirstMessageDesc": "Lấy tin nhắn đầu tiên => {{outputVar}}",
        "v2GetAlertInput": "Lấy đầu vào cảnh báo",
        "v2GetAlertInputDesc": "Lấy đầu vào cảnh báo => {{outputVar}}",
        "v2GetAlertSelect": "Lấy lựa chọn cảnh báo",
        "v2GetAlertSelectDesc": "Lấy lựa chọn cảnh báo {{display}} tùy chọn {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "Trigger không được hỗ trợ",
        "v2UnsupportedTriggerDesc": "Trigger không được hỗ trợ",
        "v2GetDisplayState": "Lấy trạng thái hiển thị",
        "v2GetDisplayStateDesc": "Lấy trạng thái hiển thị => {{outputVar}}",
        "v2SetDisplayState": "Đặt trạng thái hiển thị",
        "v2SetDisplayStateDesc": "Đặt trạng thái hiển thị thành {{value}}",
        "v2UpdateGUI": "Cập nhật GUI",
        "v2UpdateGUIDesc": "Cập nhật GUI",
        "v2UpdateChatAt": "Cập nhật trò chuyện tại chỉ số",
        "v2UpdateChatAtDesc": "Vẽ lại trò chuyện tại {{index}}",
        "v2Wait": "Chờ",
        "v2WaitDesc": "Chờ {{value}} giây",
        "v2GetRequestState": "Lấy nội dung dữ liệu yêu cầu",
        "v2GetRequestStateDesc": "Lấy nội dung yêu cầu tại {{index}} => {{outputVar}}",
        "v2SetRequestState": "Đặt nội dung dữ liệu yêu cầu",
        "v2SetRequestStateDesc": "Đặt nội dung yêu cầu tại {{index}} thành {{value}}",
        "v2GetRequestStateRole": "Lấy vai trò dữ liệu yêu cầu",
        "v2GetRequestStateRoleDesc": "Lấy vai trò dữ liệu yêu cầu tại {{index}} => {{outputVar}}",
        "v2SetRequestStateRole": "Đặt vai trò dữ liệu yêu cầu",
        "v2SetRequestStateRoleDesc": "Đặt vai trò dữ liệu yêu cầu tại {{index}} thành {{value}}",
        "v2GetRequestStateLength": "Lấy độ dài dữ liệu yêu cầu",
        "v2GetRequestStateLengthDesc": "Lấy độ dài dữ liệu yêu cầu => {{outputVar}}",
        "v2IfAdvanced": "Nếu",
        "v2IfAdvancedDesc": "Nếu {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "Tìm kiếm nhanh trong trò chuyện",
        "v2QuickSearchChatDesc": "Tìm kiếm nhanh {{value}} trong trò chuyện với điều kiện {{condition}} ở độ sâu {{depth}} => {{outputVar}}",
        "v2StopPromptSending": "Dừng gửi lời nhắc",
        "v2StopPromptSendingDesc": "Dừng gửi lời nhắc",
        "v2Tokenize": "Tokenize",
        "v2TokenizeDesc": "Tokenize {{value}} => {{outputVar}}",
        "v2GetAllLorebooks": "Lấy tất cả Sách truyền thuyết",
        "v2GetAllLorebooksDesc": "Lấy tất cả lời nhắc Sách truyền thuyết dưới dạng mảng => {{outputVar}}",
        "v2GetLorebookByName": "Lấy chỉ số Sách truyền thuyết theo tên",
        "v2GetLorebookByNameDesc": "Lấy mảng chỉ số Sách truyền thuyết theo tên {{name}} => {{outputVar}}",
        "v2GetLorebookByIndex": "Lấy Sách truyền thuyết",
        "v2GetLorebookByIndexDesc": "Lấy lời nhắc Sách truyền thuyết tại chỉ số {{index}} => {{outputVar}}",
        "v2CreateLorebook": "Tạo Sách truyền thuyết",
        "v2CreateLorebookDesc": "Tạo Sách truyền thuyết với tên {{name}}, khóa {{key}}, nội dung {{content}}",
        "v2ModifyLorebookByIndex": "Sửa đổi Sách truyền thuyết",
        "v2ModifyLorebookByIndexDesc": "Sửa đổi Sách truyền thuyết tại chỉ số {{index}} với tên {{name}}, khóa {{key}}, nội dung {{content}}",
        "v2DeleteLorebookByIndex": "Xóa Sách truyền thuyết",
        "v2DeleteLorebookByIndexDesc": "Xóa Sách truyền thuyết tại chỉ số {{index}}",
        "v2GetLorebookCountNew": "Lấy số lượng Sách truyền thuyết",
        "v2GetLorebookCountNewDesc": "Lấy tổng số Sách truyền thuyết => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "Đặt Sách truyền thuyết luôn hoạt động",
        "v2SetLorebookAlwaysActiveDesc": "Đặt Sách truyền thuyết tại chỉ số {{index}} luôn hoạt động thành {{value}}",
        "v2Calculate": "Tính toán",
        "v2CalculateDesc": "Tính toán {{expression}} => {{outputVar}}",
        "v2ReplaceString": "Thay thế chuỗi",
        "v2ReplaceStringDesc": "Thay thế {{source}} bằng regex {{regex}} thành {{replacement}} => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "Giá trị",
        "var": "Biến",
        "varName": "Tên biến",
        "outputVar": "Biến đầu ra",
        "name": "Tên",
        "index": "Chỉ số",
        "source": "Nguồn",
        "target": "Đích",
        "condition": "Điều kiện",
        "operator": "Toán tử",
        "role": "Vai trò",
        "location": "Vị trí",
        "prompt": "Lời nhắc",
        "model": "Mô hình",
        "start": "Bắt đầu",
        "end": "Kết thúc",
        "min": "Tối thiểu",
        "max": "Tối đa",
        "delimiter": "Dấu phân cách",
        "depth": "Độ sâu",
        "key": "Khóa",
        "alertContent": "Nội dung cảnh báo",
        "options": "Tùy chọn",
        "cmd": "Lệnh",
        "regex": "Regex",
        "replacement": "Thay thế",
        "flags": "Cờ",
        "negPrompt": "Lời nhắc phủ định",
        "resultFormat": "Định dạng kết quả",
        "activationKeys": "Khóa kích hoạt",
        "insertOrder": "Thứ tự chèn",
        "sysStart": "Hệ thống bắt đầu",
        "sysHistoryEnd": "Hệ thống kết thúc lịch sử",
        "sysPromptEnd": "Hệ thống kết thúc lời nhắc",
        "addElse": "Thêm Else",
        "alwaysActive": "Luôn hoạt động",
        "trigger": "Trigger",
        "triggerOn": "Kích hoạt bật",
        "valueTypeDesc": "Sử dụng trực tiếp giá trị đầu vào",
        "varTypeDesc": "Sử dụng giá trị được lưu trong biến",
        "conditionEqual": "Bằng (=)",
        "conditionNotEqual": "Không bằng (≠)",
        "conditionGreater": "Lớn hơn (>)",
        "conditionLess": "Nhỏ hơn (<)",
        "conditionGreaterEqual": "Lớn hơn hoặc bằng (≥)",
        "conditionLessEqual": "Nhỏ hơn hoặc bằng (≤)",
        "conditionSimilar": "Tương tự (≒)",
        "conditionContains": "Chứa (∋)",
        "conditionIn": "Trong (∈)",
        "conditionNotContains": "Không chứa (∌)",
        "conditionNotIn": "Không trong (∉)",
        "conditionTruthy": "Đúng (≡)",
        "operatorSet": "Đặt (=)",
        "operatorAdd": "Cộng (+=)",
        "operatorSubtract": "Trừ (-=)",
        "operatorMultiply": "Nhân (*=)",
        "operatorDivide": "Chia (/=)",
        "operatorModulo": "Chia lấy dư (%=)",
        "searchLoose": "Tìm kiếm lỏng lẻo",
        "searchStrict": "Tìm kiếm nghiêm ngặt",
        "searchRegex": "Tìm kiếm Regex",
        "modelMain": "Mô hình chính",
        "modelSub": "Mô hình phụ",
        "roleUser": "Người dùng",
        "roleChar": "Nhân vật",
        "roleSystem": "Hệ thống",
        "roleAssistant": "Trợ lý",
        "boolTrue": "Đúng",
        "boolFalse": "Sai",
        "boolNull": "Null",
        "helpVarName": "Nhập tên biến",
        "helpOutputVar": "Nhập tên biến để lưu kết quả",
        "helpIndex": "Chỉ số mảng hoặc tin nhắn",
        "helpRegex": "Nhập mẫu regex",
        "helpFlags": "Cờ Regex",
        "helpDelimiter": "Dấu phân cách để tách chuỗi",
        "helpActivationKeys": "Từ khóa kích hoạt phân tách bằng dấu phẩy",
        "helpInsertOrder": "Thứ tự chèn",
        "helpDepth": "Độ sâu tin nhắn để tìm kiếm",
        "helpMinMax": "Phạm vi giá trị tối thiểu và tối đa",
        "helpSlot": "Sử dụng {{slot}} để giữ nguyên",
        "expression": "Biểu thức"
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "Bạn có chắc muốn xóa \"{name}\" không?",
        "inlayDeleteMultipleConfirm": "Bạn có chắc muốn xóa ${count} tài sản được chọn không?",
        "inlayDeleteSelected": "Xóa mục đã chọn",
        "inlayDeselectAll": "Bỏ chọn tất cả",
        "inlayEmpty": "Không có tài sản nội tuyến đã lưu",
        "inlayEmptyDesc": "Hình ảnh, âm thanh và video được đính kèm hoặc tạo trong trò chuyện sẽ xuất hiện ở đây",
        "inlayExplorer": "Trình khám phá Tài sản Inlay",
        "inlaySelectAll": "Chọn tất cả",
        "inlayTotalAssets": "Tổng cộng ${count} tài sản",
    },
    "confirm": "Xác nhận",
    "goback": "Quay lại",
    "botSettings": "Cài đặt bot",
    "model": "Người mẫu",
    "apiKey": "Mã API",
    "providerURL": "URL yêu cầu",
    "providerJSON": "JSON nội dung yêu cầu",
    "mainPrompt": "Lời nhắc chính",
    "jailbreakPrompt": "Lời nhắc Bẻ khóa",
    "globalNote": "Ghi chú chung",
    "autoSuggest": "Tự động đề xuất",
    "tokens": "Mã thông báo",
    "maxContextSize": "Kích thước ngữ cảnh tối đa",
    "maxResponseSize": "Kích thước phản hồi tối đa",
    "temperature": "Nhiệt độ",
    "frequencyPenalty": "Hình phạt tần số",
    "presensePenalty": "Hình phạt có mặt",
    "advancedSettings": "Cài đặt nâng cao",
    "advancedSettingsWarn": "Cảnh báo: Nếu bạn không biết tùy chọn này làm gì, đừng thay đổi nó!",
    "formatingOrder": "Thứ tự hình thành",
    "authorNote": "Ghi chú của tác giả",
    "firstMessage": "tin nhắn đầu tiên",
    "description": "Sự miêu tả",
    "note": "Ghi chú",
    "jailbreakToggle": "Chuyển đổi Bẻ khóa",
    "charIcon": "Biểu tượng nhân vật",
    "characterDisplay": "Hiển thị ký tự",
    "viewScreen": "Màn hình nhân vật bổ sung",
    "none": "Không có",
    "emotionImage": "Hình ảnh cảm xúc",
    "noImages": "Không có hình ảnh",
    "noBias": "Không thiên vị",
    "image": "Hình ảnh",
    "name": "Tên",
    "folderName": "Tên thư mục",
    "folderRemoveConfirm": "Thư mục này chứa sách truyền thuyết. Bạn có chắc chắn muốn xóa nó và tất cả nội dung của nó không?",
    "emotion": "Tên cảm xúc",
    "value": "Giá trị",
    "reroll": "tái sinh",
    "chatList": "Danh sách trò chuyện",
    "removeChat": "Xóa tin nhắn này?",
    "loreBook": "Sách truyền thuyết",
    "character": "Tính cách",
    "Chat": "Trò chuyện",
    "globalLoreInfo": "Lorebook nhân vật áp dụng cho tất cả các cuộc trò chuyện trong nhân vật.",
    "group": "Nhóm",
    "groupLoreInfo": "Group Lorebook áp dụng cho tất cả các cuộc trò chuyện trong nhóm.",
    "localLoreInfo": "Chat Lorebook chỉ áp dụng cho cuộc trò chuyện hiện tại.",
    "removeConfirm": "Bạn có thực sự muốn xóa:",
    "removeConfirm2": "Bạn có THỰC SỰ muốn loại bỏ:",
    "exportConfirm": "Bạn có muốn xuất cái này không?",
    "insertOrder": "Thứ tự chèn",
    "activationKeys": "Phím kích hoạt",
    "activationKeysInfo": "Được phân tách bằng dấu phẩy",
    "prompt": "Lời nhắc",
    "loreBookDepth": "Độ sâu tìm kiếm Lorebook",
    "loreBookToken": "Token tối đa của Lorebook",
    "chatLoadInitialPages": "Số tin nhắn tải ban đầu",
    "chatLoadAdditionalPages": "Số tin nhắn tải thêm",
    "removeCharacter": "Xóa ký tự",
    "removeGroup": "Xóa nhóm",
    "exportCharacter": "Xuất ký tự",
    "userSetting": "Thiết lập người dùng",
    "username": "Tên của bạn",
    "userIcon": "Biểu tượng của bạn",
    "successExport": "Đã xuất thành công và tải xuống thư mục tải xuống của bạn",
    "successImport": "Đã nhập thành công",
    "importedCharacter": "Ký tự đã nhập",
    "alwaysActive": "Luôn luôn hoạt động",
    "additionalPrompt": "Lời nhắc bổ sung",
    "descriptionPrefix": "Tiền tố mô tả",
    "forceReplaceUrl": "Proxy ngược",
    "emotionWarn": "Mô hình phụ trợ được sử dụng.",
    "plugin": "Cắm vào",
    "language": "Ngôn ngữ",
    "UiLanguage": "Ngôn ngữ giao diện người dùng",
    "createfromScratch": "Tạo từ đầu",
    "importCharacter": "Nhập ký tự",
    "translator": "Người phiên dịch",
    "disabled": "Tàn tật",
    "noPluginSelected": "Mô hình được chọn làm plugin nhưng không có plugin nào được chọn.",
    "text": "Chữ",
    "UISize": "Kích thước văn bản trò chuyện",
    "newVersion": "Đã tìm thấy bản cập nhật, bạn có muốn cài đặt không?",
    "remindLaterQuestion": "Khi nào tôi nên nhắc bạn?",
    "remindIgnore": "Bỏ qua",
    "remindLater1Day": "Nhắc sau 1 ngày",
    "remindLater3Days": "Nhắc sau 3 ngày",
    "remindLater5Days": "Nhắc sau 5 ngày",
    "remindLater1Week": "Nhắc sau 1 tuần",
    "display": "Màn hình & Âm thanh",
    "useCustomBackground": "Tùy chỉnh nền",
    "translateInput": "Dịch đầu vào",
    "autoTranslation": "Dịch tự động",
    "fullscreen": "Toàn màn hình",
    "playMessage": "Phát âm thanh tin nhắn",
    "iconSize": "Kích cỡ biểu tượng",
    "createGroup": "Tạo trò chuyện nhóm",
    "groupIcon": "Biểu tượng nhóm",
    "single": "Đơn",
    "multiple": "Nhiều",
    "useCharLorebook": "Sử dụng truyền thuyết trong nhân vật",
    "selectChar": "Chọn nhân vật",
    "askLoadFirstMsg": "Chúng ta tải tin nhắn đầu tiên nhé?",
    "theme": "chủ đề",
    "editOrder": "Chỉnh sửa đơn hàng",
    "autoMode": "Chế độ tự động",
    "submodel": "Mô hình phụ trợ",
    "timeOutinSec": "Thời gian chờ (tính bằng giây)",
    "emotionPrompt": "Nhắc nhở cảm xúc",
    "singleView": "Chế độ xem đơn",
    "SpacedView": "Xem nhiều ký tự",
    "emphasizedView": "Chế độ xem nhân vật đôi",
    "pluginWarn": "Các plugin có thể gây ra sự cố khi cài đặt các plugin độc hại.",
    "pluginConfirm": "Bạn có thực sự muốn nhập plugin này không? Chỉ nhập plugin từ các nguồn đáng tin cậy.",
    "pluginContainsExternalMedia": "Plugin này chứa phương tiện bên ngoài.",
    "pluginContainsExternalJS": "Plugin này chứa Javascript bên ngoài.",
    "createGroupImg": "Tạo biểu tượng nhóm",
    "waifuWidth": "Chiều rộng trò chuyện Waifu",
    "savebackup": "Lưu Sao lưu vào google",
    "loadbackup": "Tải bản sao lưu từ google",
    "files": "Các tập tin",
    "backupConfirm": "Bạn có thực sự muốn lưu bản sao lưu?",
    "backupLoadConfirm": "Bạn có thực sự muốn tải bản sao lưu? Tất cả dữ liệu sẽ bị mất!",
    "backupLoadConfirm2": "Bạn có thực sự muốn tải bản sao lưu không? Tất cả dữ liệu sẽ bị mất!",
    "pasteAuthCode": "Vui lòng sao chép mã xác thực từ cửa sổ bật lên và dán vào đây:",
    "others": "Người khác",
    "presets": "cài đặt trước",
    "imageGeneration": "Tạo hình ảnh",
    "provider": "Các nhà cung cấp",
    "key": "Chìa khóa",
    "noData": "Không có dữ liệu",
    "currentImageGeneration": "Dữ liệu tạo hình ảnh hiện tại",
    "promptPreprocess": "Sử dụng tiền xử lý nhanh chóng",
    "SwipeRegenerate": "Sử dụng Vuốt để tái tạo",
    "instantRemove": "Xóa tiếp theo khi xóa tin nhắn",
    "instantRemoveConfirm": "Bạn có muốn xóa chỉ một tin nhắn không? Nếu bạn chọn Không thì tin nhắn sau đó cũng sẽ bị xóa.",
    "textColor": "Văn bản màu",
    "classicRisu": "Risu cổ điển",
    "highcontrast": "Độ tương phản cao",
    "quickPreset": "Bạn có thể nhanh chóng thay đổi cài đặt trước bằng Ctrl + (Chỉ mục cài sẵn)",
    "requestretrys": "Yêu cầu thử lại khi thất bại",
    "utilityBot": "Bot tiện ích",
    "ShowLog": "Hiển thị nhật ký yêu cầu",
    "waifuWidth2": "Kích thước ký tự Waifu",
    "sayNothing": "Nhập 'không nói gì' khi không nhập chuỗi",
    "regexScript": "Tập lệnh Regex",
    "type": "Kiểu",
    "editInput": "Sửa đổi đầu vào",
    "editOutput": "Sửa đổi đầu ra",
    "editProcess": "Sửa đổi dữ liệu yêu cầu",
    "loadLatest": "Tải bản sao lưu mới nhất",
    "loadOthers": "Tải các bản sao lưu khác",
    "exampleMessage": "Tin nhắn mẫu",
    "creatorNotes": "Bình luận của người sáng tạo",
    "systemPrompt": "Lời nhắc hệ thống",
    "characterNotes": "Ghi chú nhân vật",
    "personality": "Nhân cách",
    "scenario": "Kịch bản",
    "alternateGreetings": "Lời chào thay thế",
    "unrecommended": "Không được khuyến khích",
    "chatNotes": "Ghi chú trò chuyện",
    "showUnrecommended": "Hiển thị cài đặt không được đề xuất",
    "streamingDisplayOptimizationMode": "Tối ưu hiển thị streaming",
    "streamingDisplayOptimizationOff": "Tắt",
    "streamingDisplayOptimizationBalanced": "Cân bằng",
    "streamingDisplayOptimizationStrong": "Mạnh",
    "altGreet": "Tin nhắn đầu tiên thay thế",
    "scripts": "Tập lệnh",
    "settings": "Cài đặt",
    "selective": "chọn lọc",
    "SecondaryKeys": "Phím phụ",
    "useGlobalSettings": "Sử dụng Cài đặt chung",
    "recursiveScanning": "Quét đệ quy",
    "creator": "Người sáng tạo",
    "CharVersion": "Phiên bản nhân vật",
    "Speech": "Lời nói",
    "ToggleSuperMemory": "Chuyển đổi SupaBộ nhớ",
    "SuperMemory": "SupaBộ Nhớ",
    "useExperimental": "Có thể thực hiện các tính năng thử nghiệm",
    "showMemoryLimit": "Hiển thị giới hạn bộ nhớ",
    "showFirstMessagePages": "Hiển thị trang tin nhắn đầu tiên",
    "roundIcons": "Biểu tượng tròn",
    "streaming": "Truyền phát",
    "chatBot": "Bot trò chuyện",
    "otherBots": "Bot khác",
    "user": "Người dùng",
    "additionalAssets": "Tài sản bổ sung",
    "editDisplay": "Sửa đổi hiển thị",
    "community": "Cộng đồng",
    "textBackgrounds": "Màu màn hình văn bản tùy chỉnh",
    "textBorder": "Đề cương văn bản",
    "textScreenRound": "Màn hình văn bản tròn",
    "textScreenBorder": "Viền màn hình văn bản",
    "ttsReadOnlyQuoted": "Chỉ đọc trích dẫn",
    "ttsStop": "Dừng TTS",
    "askRemoval": "Yêu cầu xóa",
    "replaceGlobalNote": "Thay thế ghi chú toàn cầu",
    "charLoreBook": "Truyện nhân vật",
    "globalLoreBook": "Sách truyền thuyết toàn cầu",
    "globalRegexScript": "Regex toàn cầu",
    "accessibility": "Khả năng tiếp cận",
    "sendWithEnter": "Gửi bằng phím Enter(Shift + Enter chuyển sang gửi tin nhắn khi không kiểm tra.)",
    "fixedChatTextarea": "Cố định ở dưới khung chat",
    "clickToEdit": "Bấm vào văn bản để chỉnh sửa",
    "setNodePassword": "Đặt mật khẩu của bạn để bảo mật",
    "inputNodePassword": "Nhập mật khẩu của bạn. nếu bạn không nhớ, hãy xóa save/__password.txt trong tệp máy chủ của bạn và khởi động lại máy chủ.",
    "simple": "Đơn giản",
    "advanced": "Trình độ cao",
    "askReRollAutoSuggestions": "Đề xuất tự động cuộn lại",
    "creatingSuggestions": "Đang tạo đề xuất...",
    "orderByOrder": "Nói chuyện theo thứ tự",
    "removeFromGroup": "Bạn có thực sự muốn xóa {{char}} khỏi nhóm không?",
    "talkness": "tính nói nhiều",
    "active": "Tích cực",
    "loreRandomActivation": "Sử dụng điều kiện xác suất",
    "activationProbability": "Xác suất",
    "shareCloud": "Chia sẻ lên RisuRealm",
    "hub": "RisuRealm",
    "tags": "Thẻ",
    "backgroundHTML": "Nhúng nền",
    "copied": "Đã sao chép",
    "useChatCopy": "Sử dụng Sao chép tin nhắn trò chuyện",
    "useChatSticker": "Sử dụng nhãn dán trò chuyện",
    "useAdditionalAssetsPreview": "Sử dụng bản xem trước nội dung bổ sung",
    "autoTranslateInput": "Đầu vào dịch tự động",
    "enterMessageForTranslateToEnglish": "Nhập tin nhắn để dịch sang tiếng Anh",
    "recent": "Gần đây",
    "downloads": "Tải xuống",
    "trending": "Đang thịnh hành",
    "imageCompression": "Nén hình ảnh",
    "notLoggedIn": "Chưa đăng nhập vào tài khoản Risu",
    "googleDriveInfo": "Kết nối với Google Drive để đồng bộ dữ liệu của bạn.",
    "googleDriveConnection": "Kết nối Google Drive",
    "googleDriveConnected": "Đã kết nối Google Drive",
    "SaveDataInAccount": "Lưu dữ liệu trong tài khoản",
    "dataSavingInAccount": "Lưu dữ liệu trong tài khoản",
    "logout": "Đăng xuất",
    "loadDataFromAccount": "Tải dữ liệu từ tài khoản",
    "saveCurrentDataToAccount": "Lưu dữ liệu hiện tại vào tài khoản",
    "chatAssumed": "--",
    "proxyAPIKey": "Khóa/Mật khẩu",
    "proxyRequestModel": "Mô hình yêu cầu proxy",
    "officialWiki": "Wiki chính thức",
    "officialWikiDesc": "Wiki chính thức của Risuai. cứ thoải mái xem nhé.",
    "officialDiscord": "Bất hòa chính thức",
    "officialDiscordDesc": "Discord chính thức nói về Risuai",
    "persona": "nhân cách",
    "icon": "Biểu tượng",
    "account": "Tài khoản",
    "remove": "Di dời",
    "able": "Có thể",
    "assetWidth": "Chiều rộng tối đa của hình ảnh nội dung",
    "animationSpeed": "Tốc độ hoạt ảnh",
    "screenshot": "Ảnh chụp màn hình",
    "screenshotSaved": "Đã lưu ảnh chụp màn hình",
    "createBotwithAI": "Tạo Bot từ AI",
    "changeFolderName": "Nhập tên thư mục mới (để trống để hủy)",
    "cancel": "Hủy bỏ",
    "renameFolder": "Đổi tên thư mục",
    "changeFolderColor": "Thay đổi màu thư mục",
    "changeFolderImage": "Thay đổi hình ảnh thư mục",
    "fullWordMatching": "So khớp từ đầy đủ",
    "botSettingAtStart": "Menu Bot khi khởi chạy",
    "triggerStart": "Đang trò chuyện Gửi",
    "triggerInput": "Trên đầu ra của người dùng",
    "triggerOutput": "Trên đầu ra của nhân vật",
    "triggerManual": "Chỉ kích hoạt thủ công",
    "triggerCondVar": "Nếu có thể thay đổi",
    "triggerCondExists": "Nếu văn bản tồn tại trên trò chuyện",
    "triggerScript": "Tập lệnh kích hoạt",
    "triggerMatchRegex": "Phù hợp với Regex",
    "triggerMatchLoose": "Trận đấu lỏng lẻo",
    "triggerMatchStrict": "Trận đấu nghiêm ngặt",
    "searchDepth": "Độ sâu tìm kiếm",
    "equal": "Tương đương với",
    "notEqual": "Không bằng",
    "greater": "Lớn hơn",
    "less": "Ít hơn",
    "greaterEqual": "Lớn hơn hoặc bằng",
    "lessEqual": "Nhỏ hơn hoặc bằng",
    "triggerEffSysPrompt": "Thêm lời nhắc hệ thống",
    "triggerEffSetVar": "Sửa đổi biến",
    "triggerEffImperson": "Gửi trò chuyện",
    "triggerEffCommand": "Chạy lệnh",
    "triggerEffRunTrigger": "Chạy Trigger",
    "triggerEffStop": "Dừng gửi lời nhắc",
    "triggerEffCall": "Gọi Trigger",
    "varableName": "Tên biến",
    "role": "Vai trò",
    "location": "Vị trí",
    "promptstart": "Bắt đầu lời nhắc",
    "promptend": "Kết thúc lời nhắc",
    "historyend": "Kết thúc lịch sử",
    "always": "Luôn luôn",
    "noEffect": "không có hiệu lực",
    "invaildTriggerEffect": "Hiệu ứng này không hoạt động đối với loại kích hoạt này.",
    "operator": "Nhà điều hành",
    "TriggerSetToVar": "Đặt thành Biến",
    "TriggerAddToVar": "Thêm vào biến",
    "TriggerSubToVar": "Trừ từ biến",
    "TriggerMulToVar": "Nhân với biến",
    "TriggerDivToVar": "Chia từ biến",
    "isNull": "chưa được thiết lập",
    "ifChatIndex": "Nếu chỉ mục trò chuyện",
    "ifRandom": "Nếu ngẫu nhiên",
    "ifValue": "Nếu giá trị",
    "hideRealm": "Ẩn RisuRealm",
    "blockRealmCreator": "Chặn người sáng tạo",
    "blockRealmCreatorConfirm": "Chặn mọi nội dung RisuRealm của {{creator}}?",
    "realmCreatorBlocked": "Không thể sử dụng nội dung từ người sáng tạo RisuRealm đã bị chặn này.",
    "realmCreatorBlockedSuccess": "Đã chặn người sáng tạo.",
    "manageBlockedRealmCreators": "Quản lý người sáng tạo đã chặn",
    "blockedRealmCreators": "Người sáng tạo RisuRealm đã chặn",
    "noBlockedRealmCreators": "Chưa chặn người sáng tạo RisuRealm nào.",
    "unblockRealmCreator": "Bỏ chặn",
    "hideAllImages": "Ẩn tất cả hình ảnh",
    "popularityLevel": "{} Mức độ phổ biến",
    "colorScheme": "Bảng màu",
    "rangeStart": "Phạm vi bắt đầu",
    "rangeEnd": "Cuối phạm vi",
    "untilChatEnd": "Cho đến khi kết thúc cuộc trò chuyện",
    "usePromptTemplate": "Sử dụng mẫu nhắc nhở",
    "specialType": "Loại đặc biệt",
    "noSpecialType": "Không có loại đặc biệt",
    "forceProxyAsOpenAI": "Buộc định dạng proxy là OpenAI",
    "promptTemplate": "Mẫu nhắc nhở",
    "customInnerFormat": "Định dạng bên trong tùy chỉnh",
    "innerFormat": "Định dạng bên trong",
    "HypaMemory": "HypaBộ nhớ",
    "ToggleHypaMemory": "Chuyển đổi HypaMemory",
    "resetPromptTemplateConfirm": "Bạn có thực sự muốn đặt lại mẫu lời nhắc không?",
    "emotionMethod": "Phương pháp cảm xúc",
    "continueResponse": "Tiếp tục phản hồi",
    "showMenuChatList": "Hiển thị Menu Danh sách Trò chuyện",
    "translatorLanguage": "Ngôn ngữ dịch",
    "translatorType": "Loại dịch giả",
    "htmlTranslation": "Dịch HTML",
    "deeplKey": "Khóa API deepL",
    "deeplFreeKey": "Khóa API miễn phí deepL",
    "deeplXUrl": "deepLX URL",
    "deeplXToken": "deepLX Token",
    "exportPersona": "Xuất khẩu nhân vật",
    "importPersona": "Nhập khẩu nhân vật",
    "export": "Xuất khẩu",
    "import": "Nhập khẩu",
    "supporterThanks": "Người ủng hộ Cảm ơn",
    "supporterThanksDesc": "Cảm ơn sự hỗ trợ của bạn!",
    "donatorPatreonDesc": "Theo mặc định, nó sẽ không được hiển thị trong danh sách bảo mật. nếu bạn muốn hiển thị biệt danh của mình, hãy truy cập trang patreon của Risuai và nhấn nút liên kết.",
    "useNamePrefix": "Sử dụng tiền tố tên",
    "textAdventureNAI": "Chạy dưới dạng cuộc phiêu lưu văn bản",
    "appendNameNAI": "Nối tên vào NAI",
    "customStopWords": "Từ dừng tùy chỉnh",
    "defaultPrompt": "Lời nhắc mặc định",
    "additionalText": "Mô tả bổ sung",
    "seed": "Hạt giống (Seed)",
    "charjs": "CharacterJS",
    "depthPrompt": "Lời nhắc độ sâu",
    "largePortrait": "Chân dung",
    "lorePlus": "Sách truyền thuyết+",
    "reverseProxyOobaMode": "Chế độ Ooba",
    "joinMultiUserRoom": "Tham gia phòng đa người dùng",
    "exactTokens": "Token chính xác",
    "fixedTokens": "Token ước tính",
    "inlayViewScreen": "Màn hình Inlay",
    "imgGenPrompt": "Lời nhắc tạo hình ảnh",
    "imgGenNegatives": "Lời nhắc phủ định tạo hình ảnh",
    "imgGenInstructions": "Hướng dẫn tạo hình ảnh",
    "usePlainFetchWarn": "Vui lòng tắt tùy chọn này khi sử dụng NovelAI, vì nó có thể gây ra lỗi CORS khi sử dụng NovelAI.",
    "translationPrompt": "Lời nhắc dịch",
    "translationResponseSize": "Kích thước phản hồi dịch",
    "webdeeplwarn": "Tùy chọn này không được khuyến nghị sử dụng với phiên bản web, vì nó có thể gây ra lỗi CORS.",
    "saveBackupLocal": "Lưu sao lưu cục bộ",
    "loadBackupLocal": "Tải sao lưu cục bộ",
    "topP": "Top P",
    "genTimes": "Lựa chọn tạo",
    "cot": "Chuỗi suy nghĩ",
    "forcePlainFetch": "Buộc Plain Fetch",
    "autoFillRequestURL": "Tự động điền URL yêu cầu",
    "newOAIHandle": "Xử lý OpenAI mới",
    "inlayImage": "Tính năng hình ảnh Inlay",
    "nativeAutomark": "Native Automark thử nghiệm",
    "assistantPrefill": "Trợ lý điền trước",
    "postEndInnerFormat": "Đăng kết thúc",
    "sendChatAsSystem": "Gửi trò chuyện dưới dạng hệ thống",
    "sendName": "Gửi tên trong trò chuyện không phải nhóm",
    "utilOverride": "Ghi đè tiện ích",
    "template": "Mẫu",
    "chatAsOriginalOnSystem": "Gửi dưới dạng vai trò gốc",
    "exportAsDataset": "Xuất Lưu dưới dạng Dataset",
    "editTranslationDisplay": "Chỉnh sửa hiển thị dịch",
    "selectModel": "Chọn mô hình",
    "autoRemoveThoughtTag": "Xóa thẻ suy nghĩ",
    "customChainOfThought": "Chuỗi suy nghĩ tùy chỉnh",
    "maxThoughtTagDepth": "Độ sâu thẻ suy nghĩ tối đa",
    "openRouterFallback": "Sử dụng dự phòng",
    "openRouterMiddleOut": "Sử dụng Middle Out",
    "openRouterProviderOrder": "Thứ tự ưu tiên nhà cung cấp",
    "openRouterProviderOnly": "Nhà cung cấp được phép",
    "openRouterProviderIgnore": "Nhà cung cấp bị bỏ qua",
    "openRouterSearchModel": "Tìm kiếm mô hình...",
    "openRouterSortByName": "Tên",
    "openRouterSortByPrice": "Giá",
    "openRouterSortByProvider": "Nhà cung cấp",
    "openRouterSortAsc": "Tăng dần",
    "openRouterSortDesc": "Giảm dần",
    "geminiApiKey": "Khóa API Gemini",
    "removePunctuationHypa": "Xóa dấu câu bộ nhớ",
    "memoryLimitThickness": "Độ dày giới hạn bộ nhớ",
    "inputCardPassword": "Nhập mật khẩu thẻ",
    "ccv2Desc": "Character Card V2 là định dạng được sử dụng rộng rãi trong các chương trình chatbot.",
    "ccv3Desc": "Character Card V3 là định dạng thế hệ tiếp theo được sử dụng trong các chương trình chatbot.",
    "realmDesc": "RisuRealm là nền tảng chia sẻ nội dung cho Risuai. Bạn có thể chia sẻ nhân vật của mình cho người dùng khác.",
    "rccDesc": "Risu Refined Character Card là định dạng có các tính năng bổ sung như mật khẩu, kiểm tra tính toàn vẹn, v.v.",
    "password": "Mật khẩu",
    "license": "Giấy phép",
    "licenseDesc": "Bạn có thể chọn giấy phép cho người tải xuống để giới hạn việc sử dụng lời nhắc của thẻ.",
    "passwordDesc": "Bạn có thể đặt mật khẩu để bảo vệ thẻ của mình khỏi truy cập trái phép.",
    "largePersonaPortrait": "Chân dung Persona",
    "module": "Mô-đun",
    "modules": "Mô-đun",
    "noModules": "Không có mô-đun nào được cài đặt.",
    "createModule": "Tạo mô-đun",
    "basicInfo": "Thông tin cơ bản",
    "moduleContent": "Nội dung mô-đun",
    "confirmRemoveModuleFeature": "Bạn có thực sự muốn xóa tính năng này không? Hành động này không thể hoàn tác.",
    "editModule": "Chỉnh sửa mô-đun",
    "importModule": "Nhập mô-đun",
    "download": "Tải xuống",
    "edit": "Chỉnh sửa",
    "enableGlobal": "Bật toàn cầu",
    "chatModulesInfo": "Bạn có thể bật hoặc tắt mô-đun cho cuộc trò chuyện này. Bạn cũng có thể bật cho nhân vật này bằng cách nhấp chuột phải hoặc nhấn và giữ nút bật.",
    "sideMenuRerollButton": "Nút Reroll menu bên",
    "persistentStorage": "Lưu trữ liên tục",
    "persistentStorageSuccess": "Lưu trữ đã được duy trì thành công",
    "persistentStorageFail": "Lưu trữ không được duy trì. Bạn đã từ chối yêu cầu?, hoặc trình duyệt không được hỗ trợ?",
    "persistentStorageRecommended": "Khuyên dùng Lưu trữ liên tục",
    "persistentStorageDesc": "Trình duyệt của bạn hỗ trợ lưu trữ liên tục. Điều này được khuyến nghị để có hiệu suất và trải nghiệm người dùng tốt hơn.",
    "enable": "Bật",
    "postFile": "Đăng tập tin",
    "requestInfoInsideChat": "Hiển thị thông tin yêu cầu trong trò chuyện",
    "inputTokens": "Token đầu vào",
    "outputTokens": "Token đầu ra",
    "tokenWarning": "Tính toán token có thể không chính xác. Nên sử dụng nó để tham khảo.",
    "log": "Nhật ký",
    "popularityLevelDesc": "Mức độ phổ biến tăng theo số lượt tải xuống, v.v. để ước tính, mức độ phổ biến 3.7 là khoảng 1 lượt tải xuống.",
    "additionalParams": "Tham số bổ sung",
    "heightMode": "Chế độ chiều cao",
    "useAdvancedEditor": "Sử dụng trình biên tập nâng cao",
    "noWaitForTranslate": "Không chờ dịch",
    "updateRealm": "Cập nhật lên RisuRealm",
    "updateRealmDesc": "Bạn đang cố gắng cập nhật nhân vật của mình lên RisuRealm. Điều này sẽ cập nhật nhân vật của bạn lên RisuRealm và bạn không thể hoàn tác.",
    "antiClaudeOverload": "Chống quá tải Claude",
    "activeTabChange": "Tab hiện tại bị vô hiệu hóa vì tab khác đang hoạt động. Để kích hoạt tab này, nhấp OK",
    "maxSupaChunkSize": "Kích thước SupaMemory Chunk tối đa",
    "addCharacter": "Thêm nhân vật",
    "importFromRealm": "Chọn từ RisuRealm",
    "importFromRealmDesc": "Chọn hơn 1000 nhân vật trong RisuRealm",
    "random": "Ngẫu nhiên",
    "metaData": "Siêu dữ liệu",
    "autoContinueMinTokens": "Token mục tiêu (Tự động tiếp tục)",
    "autoContinueChat": "Chống phản hồi không hoàn chỉnh (Tự động tiếp tục)",
    "removeIncompleteResponse": "Xóa câu không hoàn chỉnh",
    "tokenizer": "Tokenizer",
    "chatFormating": "Định dạng trò chuyện",
    "useInstructPrompt": "Sử dụng lời nhắc hướng dẫn",
    "hanuraiMemory": "HanuraiMemory",
    "textAreaSize": "Kích thước vùng nhập",
    "textAreaTextSize": "Kích thước văn bản vùng nhập",
    "sideBarSize": "Kích thước thanh bên",
    "embedding": "Embedding",
    "syntax": "Cú pháp",
    "run": "Chạy",
    "noMessage": "Gõ gì đó để bắt đầu trò chuyện.",
    "combineTranslation": "Kết hợp dịch",
    "dynamicAssets": "Tài sản động",
    "dynamicAssetsEditDisplay": "Sử dụng tài sản động trong hiển thị",
    "longTermMemory": "Bộ nhớ dài hạn",
    "grid": "Lưới",
    "list": "Danh sách",
    "trash": "Thùng rác",
    "trashDesc": "Các nhân vật đã xóa sẽ được chuyển vào thùng rác. Bạn có thể khôi phục hoặc xóa vĩnh viễn chúng. Các nhân vật đã xóa sẽ tự động bị xóa sau 3 ngày.",
    "shareExport": "Chia sẻ/Xuất",
    "risupresetDesc": "Định dạng Risupreset là định dạng được thiết kế dành riêng cho các cài đặt trước Risuai.",
    "risuMDesc": "Định dạng RisuM là định dạng được thiết kế dành riêng cho các mô-đun Risuai.",
    "jsonDesc": "Định dạng JSON là định dạng dễ đọc và viết cho cả con người và máy móc.",
    "nickname": "Biệt danh",
    "useRegexLorebook": "Sử dụng Regex",
    "customPromptTemplateToggle": "Chuyển đổi tùy chỉnh",
    "defaultVariables": "Biến mặc định",
    "hypaAllocatedTokens": "Token được phân bổ",
    "hypaChunkSize": "Kích thước Chunk",
    "hypaV2Desc": "HypaMemory V2 là hệ thống bộ nhớ dài hạn sử dụng cả dữ liệu tóm tắt và tìm kiếm vector.",
    "supaDesc": "SupaMemory là hệ thống bộ nhớ dài hạn sử dụng dữ liệu tóm tắt cho AI.",
    "hanuraiDesc": "HanuraiMemory là hệ thống bộ nhớ sử dụng tìm kiếm vector.",
    "lowLevelAccess": "Truy cập cấp thấp",
    "resultStoredVar": "Biến lưu trữ kết quả",
    "triggerEffRunLLM": "Chạy mô hình chính",
    "triggerEffectSendAI": "Gửi lại AI",
    "triggerEffCheckSim": "Kiểm tra độ tương đồng",
    "triggerEffShowAlert": "Hiển thị cảnh báo",
    "normal": "Bình thường",
    "error": "Lỗi",
    "input": "Đầu vào",
    "select": "Chọn",
    "options": "Tùy chọn",
    "alertContent": "Nội dung cảnh báo",
    "lowLevelAccessConfirm": "Nội dung này sử dụng Truy cập cấp thấp. Điều đó có nghĩa là nội dung này có thể truy cập trực tiếp vào mô hình AI và bộ nhớ của bạn. Bạn có thực sự muốn nhập nội dung này không?",
    "triggerLowLevelOnly": "Trigger này chỉ hoạt động với Truy cập cấp thấp. Để bật trigger này, hãy bật Truy cập cấp thấp trong cài đặt nâng cao của nhân vật hoặc mô-đun.",
    "truthy": "Đúng (Truthy)",
    "extractRegex": "Trích xuất văn bản bằng Regex",
    "runImgGen": "Chạy tạo hình ảnh",
    "cutChat": "Cắt trò chuyện",
    "modifyChat": "Sửa đổi trò chuyện",
    "regex": "Regex",
    "flags": "Cờ",
    "resultFormat": "Định dạng kết quả",
    "negPrompt": "Lời nhắc phủ định",
    "start": "Bắt đầu",
    "end": "Kết thúc",
    "index": "Chỉ số",
    "search": "Tìm kiếm",
    "goCharacterOnImport": "Đi tới nhân vật khi nhập Realm",
    "format": "Định dạng",
    "v2Warning": "Cảnh báo: Thẻ V2 không còn được hỗ trợ. Nó có thể không chứa tất cả dữ liệu.",
    "applyModule": "Áp dụng mô-đun",
    "successApplyModule": "Mô-đun đã được áp dụng thành công",
    "font": "Phông chữ",
    "lineHeight": "Chiều cao dòng",
    "loadAutoServerBackup": "Tải sao lưu máy chủ tự động",
    "notCharxWarn": "Nhân vật này sử dụng nhiều tài sản. Nên xuất nhân vật này dưới dạng định dạng CharX để tương thích tốt hơn.",
    "noPlugins": "Không có plugin nào được cài đặt",
    "legacyTranslation": "Dịch cũ",
    "clipboardSuccess": "Đã sao chép vào bảng nhớ tạm",
    "translateContent": "Dịch nội dung",
    "doNotTranslate": "Không dịch",
    "includePersonaName": "Bao gồm tên Persona",
    "hidePersonaName": "Ẩn tên Persona",
    "triggerSwitchWarn": "Nếu bạn thay đổi loại trigger, các trigger hiện tại sẽ bị mất. Bạn có muốn tiếp tục không?",
    "codeMode": "Mã",
    "blockMode": "Khối",
    "helpBlock": "Trợ giúp",
    "hideChatIcon": "Ẩn giao diện biểu tượng",
    "loadInternalBackup": "Tải sao lưu nội bộ",
    "createCopy": "Tạo bản sao",
    "bindPersona": "Liên kết Persona",
    "chatOptions": "Tùy chọn trò chuyện",
    "doYouWantToBindCurrentPersona": "Bạn có muốn liên kết persona hiện tại vào cuộc trò chuyện này không?",
    "doYouWantToUnbindCurrentPersona": "Bạn có muốn hủy liên kết persona khỏi cuộc trò chuyện này không?",
    "personaBindedSuccess": "Persona đã được liên kết thành công",
    "personaUnbindedSuccess": "Persona đã được hủy liên kết thành công",
    "parameters": "Tham số",
    "sizeAndSpeed": "Kích thước và Tốc độ",
    "useLegacyGUI": "Sử dụng GUI cũ",
    "claudeCachingExperimental": "Lưu trữ đệm Claude",
    "openClose": "Mở/Đóng",
    "hideApiKeys": "Ẩn khóa API",
    "unformatQuotes": "Tắt định dạng trích dẫn",
    "enableDevTools": "Bật công cụ phát triển",
    "selectFile": "Chọn tập tin",
    "namespace": "Namespace",
    "moduleIntergration": "Tích hợp mô-đun",
    "previewInfo": "Bản xem trước này hiển thị lời nhắc trước khi xử lý theo mô hình cụ thể.",
    "miscTools": "Công cụ khác",
    "promptConvertion": "Chuyển đổi lời nhắc",
    "convertionStep1": "Chọn tất cả tập tin liên quan đến lời nhắc (Context, Instruct và Sampler JSON được hỗ trợ)",
    "customCSS": "CSS tùy chỉnh",
    "betaMobileGUI": "GUI di động Beta",
    "menu": "Menu",
    "connectionOpen": "Mở kết nối",
    "connectionOpenInfo": "Phòng đa người dùng đã được mở. Bạn có thể chia sẻ mã phòng cho người dùng khác. Người khác có thể tham gia phòng bằng cách sử dụng mã trong playground > Tham gia phòng đa người dùng.",
    "createMultiuserRoom": "Tạo phòng đa người dùng",
    "connectionHost": "Bạn là chủ phòng.",
    "connectionGuest": "Bạn là khách của phòng.",
    "otherUserRequesting": "Người dùng khác đang yêu cầu. Hãy thử lại sau.",
    "jsonSchema": "JSON Schema",
    "enableJsonSchema": "Bật Schema",
    "strictJsonSchema": "Schema nghiêm ngặt",
    "extractJson": "Trích xuất JSON",
    "reloadSession": "Đã tìm thấy phiên bản dữ liệu lưu mới hơn. Đang tải lại phiên...",
    "fixMarkdownNewline": "Sửa lỗi xuống dòng Markdown",
    "customQuotes": "Dấu ngoặc kép tùy chỉnh",
    "leadingSingleQuote": "Dấu ngoặc đơn mở đầu",
    "leadingDoubleQuote": "Dấu ngoặc kép mở đầu",
    "trailingSingleQuote": "Dấu ngoặc đơn kết thúc",
    "trailingDoubleQuote": "Dấu ngoặc kép kết thúc",
    "translatorNote": "Ghi chú của người dịch",
    "formatGroupInSingle": "Định dạng nhóm trong đơn",
    "groupInnerFormat": "Định dạng nội bộ không phải người nói",
    "groupOtherBotRole": "Vai trò không phải người nói trong nhóm",
    "defineCustomGUI": "Xác định GUI tùy chỉnh",
    "chatHTML": "HTML trò chuyện",
    "logShare": "Hiển thị nút chia sẻ nhật ký",
    "preview": "Xem trước",
    "recommended": "Được đề xuất",
    "newChat": "Cuộc trò chuyện mới",
    "predictedOutput": "Đầu ra dự đoán",
    "systemContentReplacement": "Thay thế nội dung hệ thống",
    "systemRoleReplacement": "Thay thế vai trò hệ thống",
    "seperateParameters": "Tham số riêng biệt",
    "seperateParametersEnabled": "Bật tham số riêng biệt",
    "summarizationPrompt": "Lời nhắc tóm tắt",
    "reSummarizationPrompt": "Lời nhắc tóm tắt lại",
    "translatorPrompt": "Lời nhắc dịch",
    "translateBeforeHTMLFormatting": "Dịch trước khi định dạng HTML",
    "retranslate": "Dịch lại",
    "editTranslation": "Chỉnh sửa bản dịch",
    "editTranslationSave": "Lưu bản dịch",
    "exportTranslationCache": "Xuất bộ nhớ đệm dịch",
    "exportTranslationCacheSuccess": "Đã xuất bộ nhớ đệm dịch thuật thành công.",
    "importTranslationCache": "Nhập bộ nhớ đệm dịch",
    "importTranslationCacheConfirm": "Thao tác này sẽ hợp nhất các mục vào bộ nhớ đệm dịch thuật. Các khóa hiện có sẽ bị ghi đè. Tiếp tục?",
    "importTranslationCacheSuccess": "Đã nhập {0} mục bộ nhớ đệm dịch.",
    importTranslationCacheFailed: "Đã nhập {0} mục, nhưng {1} mục không lưu được. Bộ nhớ có thể đã đầy.",
    "exportTranslationCacheEmpty": "Bộ nhớ đệm dịch trống.",
    clearTranslationCache: "Xóa bộ nhớ đệm dịch thuật",
    clearTranslationCacheSuccess: "Đã xóa bộ nhớ đệm dịch thuật.",
    clearTranslationCacheConfirm: "Thao tác này sẽ xóa tất cả mục trong bộ nhớ đệm dịch thuật. Không thể hoàn tác. Tiếp tục?",
    "loading": "Đang tải",
    "autoTranslateCachedOnly": "Chỉ tự động dịch các tin nhắn đã lưu vào bộ nhớ đệm",
    "notification": "Thông báo",
    "permissionDenied": "Quyền bị từ chối bởi trình duyệt hoặc hệ điều hành của bạn",
    "customFlags": "Cờ tùy chỉnh",
    "enableCustomFlags": "Bật cờ tùy chỉnh",
    "googleCloudTokenization": "Tokenization Google Cloud",
    "presetChain": "Chuỗi cài đặt trước",
    "legacyMediaFindings": "Tìm kiếm phương tiện cũ",
    "staticsDisclaimer": "Thống kê dựa trên dữ liệu sau tháng 7 năm 2024. Dữ liệu có thể không chính xác.",
    "subtitles": "Phụ đề",
    "subtitlesWarning1": "Bạn phải sử dụng mô hình có đầu vào âm thanh/video để sử dụng tính năng này.",
    "subtitlesWarning2": "Bạn phải sử dụng mô hình có tính năng phát trực tuyến để sử dụng tính năng này.",
    "reset": "Đặt lại",
    "assetMaxDifference": "Sự khác biệt tối đa của tài sản",
    "sourceLanguage": "Ngôn ngữ nguồn",
    "destinationLanguage": "Ngôn ngữ đích",
    "noWebGPU": "Trình duyệt hoặc hệ điều hành của bạn không hỗ trợ WebGPU. Điều này sẽ làm chậm hiệu suất đáng kể.",
    "menuSideBar": "Thanh bên menu",
    "home": "Trang chủ",
    "showSavingIcon": "Hiển thị biểu tượng đang lưu",
    "pluginVersionWarn": "Đây là phiên bản {{plugin_version}} của plugin, không tương thích với phiên bản Risuai này. Vui lòng cập nhật plugin lên phiên bản {{required_version}}.",
    "imageTranslation": "Dịch hình ảnh",
    "banCharacterset": "Tự động tạo lại khi gặp bộ ký tự",
    "realmDirectOpen": "Mở trực tiếp nhân vật trong RisuRealm",
    "showPromptComparison": "Hiển thị so sánh lời nhắc",
    "inlayErrorResponse": "Phản hồi lỗi Inlay",
    "triggerOn": "Kích hoạt bật",
    "noConfig": "Không có cấu hình",
    "varName": "Tên biến",
    "var": "Biến",
    "condition": "Điều kiện",
    "trigger": "Trigger",
    "outputVar": "Biến đầu ra",
    "source": "Nguồn",
    "cmd": "Lệnh",
    "sysStart": "Hệ thống bắt đầu",
    "sysHistoryEnd": "Hệ thống kết thúc lịch sử",
    "sysPromptEnd": "Hệ thống kết thúc lời nhắc",
    "target": "Đích",
    "addElse": "Thêm Else",
    "min": "Tối thiểu",
    "max": "Tối đa",
    "delimiter": "Dấu phân cách",
    "deleteCount": "Số lượng xóa",
    "triggerEffRunAxLLM": "Chạy mô hình phụ trợ",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 là hệ thống bộ nhớ dài hạn sử dụng cả tóm tắt và tìm kiếm vector.",
        "supaMemoryPromptPlaceHolder": "Để trống để sử dụng giá trị mặc định",
        "maxMemoryTokensRatioLabel": "Tỷ lệ Token Bộ nhớ Tối đa (Ước tính)",
        "maxMemoryTokensRatioError": "Không thể tính toán Tỷ lệ Token Bộ nhớ Tối đa",
        "memoryTokensRatioLabel": "Tỷ lệ Token Bộ nhớ",
        "extraSummarizationRatioLabel": "Tỷ lệ Tóm tắt Bổ sung",
        "maxChatsPerSummaryLabel": "Số Tin nhắn Tối đa cho mỗi Tóm tắt",
        "recentMemoryRatioLabel": "Tỷ lệ Bộ nhớ Gần đây",
        "similarMemoryRatioLabel": "Tỷ lệ Bộ nhớ Tương tự",
        "randomMemoryRatioLabel": "Tỷ lệ Bộ nhớ Ngẫu nhiên",
        "enableSimilarityCorrectionLabel": "Bật Hiệu chỉnh Độ tương tự",
        "preserveOrphanedMemoryLabel": "Giữ Bộ nhớ Mồ côi",
        "applyRegexScriptWhenRerollingLabel": "Áp dụng Script Regex khi Tạo lại",
        "doNotSummarizeUserMessageLabel": "Không Tóm tắt Tin nhắn Người dùng"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "Hành động này không thể hoàn tác. Bạn có muốn đặt lại dữ liệu HypaV3 không?",
        "resetConfirmSecondMessage": "Hành động này không thể khôi phục. Bạn có thực sự chắc chắn muốn đặt lại dữ liệu HypaV3 không?",
        "convertLabel": "Chưa có tóm tắt nào, nhưng bạn có thể chuyển đổi dữ liệu HypaV2 sang V3.",
        "convertButton": "Chuyển đổi sang V3",
        "convertSuccessMessage": "Đã chuyển đổi thành công dữ liệu HypaV2 sang V3",
        "convertErrorMessage": "Chuyển đổi dữ liệu HypaV2 sang V3 thất bại: {0}",
        "noSummariesLabel": "Chưa có tóm tắt nào",
        "searchPlaceholder": "Nhập #N, ID hoặc từ khóa",
        "summaryNumberLabel": "Tóm tắt #{0}",
        "deleteThisConfirmMessage": "Xóa bản tóm tắt này?",
        "deleteAfterConfirmMessage": "Xóa tất cả các tóm tắt sau tóm tắt này?",
        "deleteAfterConfirmSecondMessage": "Hành động này không thể hoàn tác. Bạn có chắc chắn không?",
        "translationLabel": "Bản dịch",
        "rerolledSummaryLabel": "Tóm tắt đã Tạo lại",
        "rerolledTranslationLabel": "Bản dịch Tóm tắt đã Tạo lại",
        "connectedMessageCountLabel": "Tin nhắn Liên kết ({0})",
        "connectedFirstMessageLabel": "Tin nhắn Đầu tiên",
        "connectedMessageRoleLabel": "Tin nhắn của {0}",
        "connectedMessageNotFoundLabel": "Không tìm thấy tin nhắn",
        "connectedMessageLoadingError": "Lỗi khi tải tin nhắn liên kết: {0}",
        "connectedMessageTranslationLabel": "Bản dịch",
        "nextSummarizationFirstMessageLabel": "Tin nhắn Đầu tiên",
        "nextSummarizationNoMessageIdLabel": "Không có ID Tin nhắn",
        "nextSummarizationLabel": "HypaV3 sẽ tóm tắt [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "CẢNH BÁO: Không tìm thấy tin nhắn",
        "nextSummarizationLoadingError": "Lỗi khi tải mục tiêu tóm tắt tiếp theo: {0}",
        "summarizationConditionLabel": "Mẹo: HypaV3 bắt đầu tóm tắt khi số lượng token đầu vào vượt quá kích thước ngữ cảnh tối đa.",
        "emptySelectedFirstMessageLabel": "CẢNH BÁO: Tin nhắn đầu tiên được chọn trống",
        "unclassified": "Chưa phân loại",
        "reSummarize": "Tóm tắt lại",
        "reSummarizing": "Đang tóm tắt lại...",
        "reSummarizeResult": "Kết quả tóm tắt lại",
        "retry": "Thử lại",
        "translate": "Dịch",
        "tag": "Thẻ",
        "tagManager": "Quản lý thẻ",
        "tagManagerTitle": "Quản lý thẻ - Tóm tắt #{0}",
        "newTagName": "Tên thẻ mới",
        "noTagsYet": "Chưa có thẻ nào.",
        "addNewTagHint": "Thêm thẻ mới ở trên.",
        "categoryManager": "Danh mục",
        "allCategories": "Tất cả",
        "categoryName": "Tên danh mục",
        "noCategoriesYet": "Chưa có danh mục nào.",
        "addNewCategoryHint": "Nhấp vào nút + ở trên để thêm một cái."
    },
    "bulkEnabling": "Bật hàng loạt Lorebook",
    "showTranslationLoading": "Hiển thị đang tải bản dịch",
    "showDeprecatedTriggerV1": "Hiển thị Trigger V1 đã lỗi thời",
    "showDeprecatedTriggerV2": "Hiển thị Trigger V2 đã lỗi thời",
    "triggerV1Warning": "Trigger V1 đã lỗi thời. Nó có thể bị xóa trong tương lai.",
    "copy": "Sao chép",
    "paste": "Dán",
    "depth": "Độ sâu",
    "returnCSSError": "Trả về lỗi CSS",
    "alwaysActiveInChat": "Luôn hoạt động (Trò chuyện hiện tại)",
    "childLoreDesc": "Đây là bản sao của cốt truyện nhân vật vẫn 'Luôn hoạt động' cho đến khi bị xóa hoặc tắt thủ công trong bản gốc.",
    "thinkingTokens": "Token suy nghĩ",
    "antiServerOverload": "Chống quá tải máy chủ",
    "localActivationInGlobalLorebook": "Kích hoạt cục bộ trong Lorebook toàn cầu",
    "cachePoint": "Điểm lưu trữ",
    "all": "Tất cả",
    "showFolderNameInIcon": "Hiển thị tên thư mục trong biểu tượng",
    "claudeCachingRetrival": "Truy xuất bộ nhớ đệm Claude",
    "claudeCachingRetrivalDesc": "Kéo dài thời gian lưu trữ bộ nhớ đệm Claude bằng cách yêu cầu mỗi 4 phút. Điều này có thể giảm tỷ lệ bỏ lỡ bộ nhớ đệm, nhưng có thể tăng chi phí nếu không sử dụng đúng cách.",
    "automaticCachePoint": "Điểm lưu trữ tự động",
    "experimentalChatCompression": "Xử lý dữ liệu trò chuyện thử nghiệm",
    "loadingChatData": "Đang tải dữ liệu trò chuyện",
    "outputImageModal": "Modal hình ảnh đầu ra",
    "playMessageOnTranslateEnd": "Phát âm thanh khi hoàn thành dịch",
    "auxModelUnderModelSettings": "Hiển thị tách biệt mô hình phụ trong cài đặt mô hình",
    "seperateModelsForAxModels": "Tách biệt mô hình cho các mô hình phụ trợ",
    "axModelsDef": "Định nghĩa mô hình Ax",
    "doNotChangeSeperateModels": "Không thay đổi mô hình tách biệt khi thay đổi cài đặt trước",
    "tools": "Công cụ",
    "action": "Hành động",
    "hotkey": "Phím nóng",
    "hotkeyDesc": {
        "reroll": "Tạo lại (Reroll)",
        "unreroll": "Hoàn tác tạo lại",
        "translate": "Dịch",
        "remove": "Xóa",
        "edit": "Chỉnh sửa",
        "copy": "Sao chép",
        "send": "Gửi",
        "settings": "Cài đặt",
        "home": "Trang chủ",
        "presets": "Chọn nhanh cài đặt trước",
        "persona": "Chọn nhanh Persona",
        "modelSelect": "Chọn nhanh mô hình",
        "toggleCSS": "Bật/Tắt CSS",
        "prevChar": "Nhân vật trước",
        "nextChar": "Nhân vật tiếp theo",
        "quickMenu": "Menu nhanh",
        "quickSettings": "Cài đặt nhanh",
        "toggleVoice": "Bật/Tắt giọng nói",
        "toggleLog": "Bật/Tắt nhật ký",
        "previewRequest": "Xem trước yêu cầu",
        "import": "Nhập",
        "export": "Xuất",
        "webcam": "Bật/Tắt Webcam",
        "focusInput": "Tập trung vào đầu vào",
        "scrollToActiveChar": "Cuộn đến nhân vật đang hoạt động"
    },
    "screenTooSmall": "Màn hình quá nhỏ để hiển thị giao diện.",
    "advancedModelSettings": "Cài đặt mô hình nâng cao",
    "fallbackModel": "Mô hình dự phòng",
    "fallbackWhenBlankResponse": "Dự phòng khi phản hồi trống",
    "doNotChangeFallbackModels": "Không thay đổi mô hình dự phòng khi thay đổi cài đặt trước",
    "customModels": "Mô hình tùy chỉnh",
    "igpPrompt": "Lời nhắc IGP",
    "useTokenizerCaching": "Lưu trữ đệm Tokenizer",
    "hypaMemoryV2Modal": "Hypa V2 Modal",
    "hypaMemoryV3Modal": "Hypa V3 Modal",
    "showMenuHypaMemoryModal": "Hiển thị Menu Hypa Modal",
    "promptInfoInsideChat": "Thêm thông tin lời nhắc vào trò chuyện",
    "promptTextInfoInsideChat": "Thêm văn bản lời nhắc vào trò chuyện",
    "promptInfoEmptyMessage": "Không có thông tin lời nhắc cho tin nhắn này.",
    "promptInfoEmptyToggle": "Không có chuyển đổi tùy chỉnh nào đang hoạt động.",
    "promptInfoEmptyText": "Chưa có văn bản lời nhắc nào được lưu.",
    "escapeOutput": "Thoát đầu ra",
    "openAIFlexProcessing": "Xử lý Flex OpenAI",
    "claudeBatching": "Xử lý hàng loạt Claude",
    "claude1HourCaching": "Lưu trữ đệm Claude 1 giờ",
    "folderNameInput": "Vui lòng nhập tên thư mục mới",
    "folderRemoveLengthError": "Để xóa thư mục, nó phải không chứa bất kỳ mục nào.",
    "personaNotePlaceholder": "Nhập mã định danh duy nhất cho persona này. Ví dụ: \"Persona thợ săn\"",
    "mcpAccessPrompt": "{{tool}} đang cố gắng \"{{action}}\". Bạn có muốn cho phép điều này không?",
    "rememberToolUsage": "Ghi nhớ việc sử dụng công cụ",
    "simplifiedToolUse": "Sử dụng công cụ đơn giản hóa",
    "toolCalled": "Công cụ '{{tool}}' đã được gọi",
    "static": "Tĩnh",
    "dynamic": "Động",
    "assetStyle": "Phong cách tài sản",
    "insertAssetPrompt": "Chèn lời nhắc tài sản",
    "requestLocation": "Yêu cầu vị trí",
    "newImageHandlingBeta": "Xử lý hình ảnh mới (Beta)",
    "settingsExported": "Cài đặt báo cáo lỗi đã được xuất và sao chép vào bảng nhớ tạm.",
    "bookmarks": "Dấu trang",
    "noBookmarks": "Không có dấu trang",
    "bookmarkAskNameOrDefault": "Nhập tên dấu trang. Nếu không nhập, nó sẽ được gán tự động.",
    "bookmarkAskNameOrCancel": "Nhập tên dấu trang. Nếu không nhập, việc đổi tên sẽ bị hủy.",
    "collapseAll": "Thu gọn tất cả",
    "expandAll": "Mở rộng tất cả",
    "hideErrorDetails": "Ẩn chi tiết lỗi",
    "showErrorDetails": "Hiển thị chi tiết lỗi",
    "dynamicOutput": "Đầu ra động",
    "autoAdjustSchema": "Tự động điều chỉnh Schema",
    "dynamicMessages": "Tin nhắn động",
    "dynamicMemory": "Bộ nhớ động",
    "dynamicResponseTiming": "Thời gian phản hồi động",
    "showTypingEffect": "Hiển thị hiệu ứng gõ",
    "dynamicRequest": "Yêu cầu động",
    "dynamicOutputPrompt": "Lời nhắc đầu ra động",
    "settingsCloseButtonSize": "Kích thước nút đóng cài đặt",
    "translating": "Đang dịch...",
    "stackTraceTranslationFailed": "Dịch dấu vết ngăn xếp thất bại. Hiển thị dấu vết ngăn xếp bị làm rối ban đầu bên dưới.",
    "translate": "Dịch địa chỉ mã",
    "apply": "Áp dụng",
    "add": "Thêm",
    "nightlyWarning": "## Bản dựng Nightly\n\nBạn đang kết nối với bản dựng Nightly của phần mềm. Phiên bản này dùng để thử nghiệm và rất có thể có lỗi. **Trong phiên bản này, ngay cả khi bạn gặp sự cố, chúng tôi không hỗ trợ giải quyết trực tiếp.**",
    "loginSionyw": "Đăng nhập bằng tài khoản Sionyw",
    "pluginRiskDetectedAlert": "Risuai phát hiện mã có thể gây hại, có thể ĂN CẮP KHÓA API HOẶC DỮ LIỆU CÁ NHÂN CỦA BẠN. Chúng tôi khuyên bạn KHÔNG NÊN CÀI ĐẶT PLUGIN NÀY.",
    "doNotInstall": "Không cài đặt",
    "continueAnyway": "Vẫn tiếp tục",
    "pluginNoRiskButAlert": "Risuai không phát hiện mã độc hại, nhưng xin lưu ý rằng việc cài đặt plugin từ các nguồn không tin cậy có thể gây rủi ro bảo mật.",
    "pluginRisksInuserFriendly": {
        "eval": "Đánh giá mã từ chuỗi",
        "globalAccess": "Truy cập biến toàn cục",
        "thisOutsideClass": "Sử dụng 'this' bên ngoài ngữ cảnh lớp",
        "errorInVerification": "Lỗi trong quá trình xác minh",
        "storageAccess": "Truy cập bộ nhớ"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "Plugin cố gắng thực thi mã từ chuỗi, chuỗi có thể bị làm mờ để ẩn mã độc hại.",
        "globalAccess": "Plugin cố gắng truy cập các biến toàn cục, điều này có thể dẫn đến các tác dụng phụ không mong muốn hoặc lỗ hổng bảo mật.",
        "thisOutsideClass": "Plugin sử dụng từ khóa 'this' bên ngoài ngữ cảnh lớp, điều này có thể dẫn đến hành vi không mong muốn hoặc các vấn đề bảo mật.",
        "errorInVerification": "Có lỗi trong quá trình xác minh plugin, cho thấy các vấn đề tiềm ẩn với chức năng của nó.",
        "storageAccess": "Plugin cố gắng truy cập bộ nhớ, điều này có thể dẫn đến rò rỉ dữ liệu hoặc thao tác dữ liệu trái phép."
    },
    "generatedByAIDisclaimer": "Nội dung này được tạo bởi AI và có thể chứa thông tin không chính xác hoặc thiên kiến.",
    "aiGenerationWarning": "Nội dung sẽ được tạo bởi AI và có thể chứa thông tin không chính xác hoặc thiên kiến.",
    "noRequestLogs": "Không có nhật ký yêu cầu nào.",
    "bookmark": "Dấu trang",
    "duplicatePluginFoundUpdateIt": "Phát hiện plugin trùng lặp. Bạn có muốn cập nhật plugin hiện có không?",
    "pluginUpdateFoundInstallIt": "Đã tìm thấy bản cập nhật plugin. Bạn có muốn cài đặt bản cập nhật này không?",
    "branchedText": "Cuộc trò chuyện này đã được rẽ nhánh từ {}.",
    "loadMore": "Tải thêm",
    "goToChat": "Đi đến Chat",
    "branch": "Chi nhánh",
    "newMessage": "Tin nhắn mới",
    "autoScrollToNewMessage": "Tự động cuộn đến tin nhắn mới",
    "alwaysScrollToNewMessage": "Luôn cuộn đến tin nhắn mới (bỏ qua vị trí cuộn)",
    "newMessageButtonStyle": "Kiểu nút tin nhắn mới",
    "disableAbove": "Cắt tin nhắn cho AI",
    "newMessageButtonBottomRight": "Dưới cùng bên phải",
    "disableMessage": "Vô hiệu hóa tin nhắn",
    "newMessageButtonFloatingCircle": "Vòng tròn nổi (Góc dưới bên phải)",
    "newMessageButtonBottomLeft": "Phía dưới bên trái",
    "newMessageButtonBottomCenter": "Dưới cùng ở giữa (Mặc định)",
    "fetchLogConsent": "Plugin {} đang yêu cầu truy xuất nhật ký, hành động này có thể làm lộ thông tin nhạy cảm. Bạn có muốn cho phép điều này không?",
    "providerPermissionDenied": "Người dùng đã từ chối quyền truy cập nhà cung cấp của plugin.",
    "newMessageButtonTopBar": "Thanh trên cùng",
    "pluginDevelopMode": "Chế độ phát triển Plugin",
    "mainDomAccessConsent": "Plugin {} đang yêu cầu truy cập vào Tài liệu chính, điều này có thể làm lộ thông tin nhạy cảm. Bạn có muốn cho phép không?",
    "getFullDatabaseConsent": "Plugin {} đang yêu cầu truy cập vào toàn bộ cơ sở dữ liệu, điều này có thể làm lộ thông tin nhạy cảm. Bạn có muốn cho phép điều này không?",
    "enableScrollToActiveChar": "Bật cuộn đến nhân vật đang hoạt động",
    "trimStartNewChat": "Rút gọn các tin nhắn 'Bắt đầu đoạn chat mới'",
    "newMessageButtonRightCenter": "Trung tâm bên phải",
    "hamburgerButtonBottom": "Di chuyển nút menu xuống dưới cùng của thanh bên",
    "keepSessionAlive": "Duy trì phiên",
    "keepSessionAlivePip": "Qua PiP",
    "keepSessionAliveSound": "Qua âm thanh",
    "nanoGPTLoadingAccountInfo": "Đang tải thông tin tài khoản…",
    "nanoGPTCreditBalance": "Số dư tín dụng:",
    "nanoGPTSubscription": "Đăng ký",
    "nanoGPTGraceUntil": (date: string) => `đến ${date}`,
    "nanoGPTNoActiveSubscription": "Không có đăng ký đang hoạt động.",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `Hủy vào cuối kỳ (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `Token đầu vào hàng tuần — đã dùng ${pct}`,
    "nanoGPTDailyTokens": (pct: string) => `Token đầu vào hàng ngày — đã dùng ${pct}`,
    "nanoGPTDailyImages": (pct: string) => `Hình ảnh hàng ngày — đã dùng ${pct}`,
    "nanoGPTResets": (date: string) => `Đặt lại vào ${date}`,
    "nanoGPTUsed": (n: string) => `Đã dùng ${n}`,
    "nanoGPTRemaining": (n: string) => `Còn lại ${n}`,
    "nanoGPTRenews": (date: string) => `Gia hạn: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "Không thể tải thông tin tài khoản.",
    "nanoGPTWeeklyTokensLabel": "Token đầu vào hàng tuần",
    "nanoGPTDailyTokensLabel": "Token đầu vào hàng ngày",
    "nanoGPTDailyImagesLabel": "Hình ảnh hàng ngày",
    "nanoGPTUsedLabel": "đã dùng",
    "nanoGPTRemainingLabel": "còn lại",
    "nanoGPTResetsLabel": "Đặt lại",
    "nanoGPTRenewsLabel": "Gia hạn:",
    "nanoGPTProvider": "Nhà cung cấp",
    "nanoGPTProviderPayAsYouGoOnly": "(chỉ khả dụng ở chế độ trả theo lượng dùng)",
    "nanoGPTProviderAuto": "Tự động",
    "nanoGPTProviderFree": "Miễn phí",
    "nanoGPTProviderInput": "Đầu vào",
    "nanoGPTProviderOutput": "Đầu ra",
    "nanoGPTProviderQuantization": "Lượng tử hóa",
    "nanoGPTProviderUndisclosed": "Chưa công bố",
    "nanoGPTProviderCache": "Bộ nhớ đệm",
    "nanoGPTProviderCacheSupported": "Hỗ trợ",
    "nanoGPTProviderCacheNotSupported": "Không hỗ trợ",
    "nanoGPTProviderCacheRead": "Đọc bộ nhớ đệm",
    "nanoGPTUseSubscriptionEndpoint": "Sử dụng endpoint và mô hình đăng ký",
    "modelGridCouldNotLoad": "Không thể tải danh sách mô hình. Kiểm tra khóa API của bạn.",
    "modelGridNoModelsMatch": (q: string) => `Không có mô hình nào khớp với "${q}"`,
    "modelGridContext": (n: string) => `Ngữ cảnh: ${n}`,

    nanoGPTSelectFromList: "Chọn từ danh sách",
    nanoGPTManualInput: "Nhập thủ công",
    nanoGPTManualModelSelect: "Chọn mô hình thủ công",
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
